var items = {
  "block.minecraft.acacia_button": "Acaciahouten knop",
  "block.minecraft.acacia_door": "Acaciahouten deur",
  "block.minecraft.acacia_fence": "Acaciahouten hek",
  "block.minecraft.acacia_fence_gate": "Acaciahouten poort",
  "block.minecraft.acacia_hanging_sign": "Acaciahouten hangbord",
  "block.minecraft.acacia_leaves": "Acaciabladeren",
  "block.minecraft.acacia_log": "Acaciastam",
  "block.minecraft.acacia_planks": "Acaciahouten planken",
  "block.minecraft.acacia_pressure_plate": "Acaciahouten drukplaat",
  "block.minecraft.acacia_sapling": "Acaciazaailing",
  "block.minecraft.acacia_shelf": "Acaciahouten schap",
  "block.minecraft.acacia_sign": "Acaciahouten bord",
  "block.minecraft.acacia_slab": "Acaciahouten plaat",
  "block.minecraft.acacia_stairs": "Acaciahouten trap",
  "block.minecraft.acacia_trapdoor": "Acaciahouten valluik",
  "block.minecraft.acacia_wall_hanging_sign": "Acaciahouten uithangbord",
  "block.minecraft.acacia_wall_sign": "Acaciahouten bord aan muur",
  "block.minecraft.acacia_wood": "Acaciahout",
  "block.minecraft.activator_rail": "Activatiespoor",
  "block.minecraft.air": "Lucht",
  "block.minecraft.allium": "Look",
  "block.minecraft.amethyst_block": "Amethistblok",
  "block.minecraft.amethyst_cluster": "Amethistcluster",
  "block.minecraft.ancient_debris": "Oud puin",
  "block.minecraft.andesite": "Andesiet",
  "block.minecraft.andesite_slab": "Andesietplaat",
  "block.minecraft.andesite_stairs": "Andesiettrap",
  "block.minecraft.andesite_wall": "Andesietmuur",
  "block.minecraft.anvil": "Aambeeld",
  "block.minecraft.attached_melon_stem": "Vaste meloenstam",
  "block.minecraft.attached_pumpkin_stem": "Vaste pompoenstam",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azaleabladeren",
  "block.minecraft.azure_bluet": "Porseleinsterretje",
  "block.minecraft.bamboo": "Bamboe",
  "block.minecraft.bamboo_block": "Bamboeblok",
  "block.minecraft.bamboo_button": "Bamboeknop",
  "block.minecraft.bamboo_door": "Bamboedeur",
  "block.minecraft.bamboo_fence": "Bamboehek",
  "block.minecraft.bamboo_fence_gate": "Bamboepoort",
  "block.minecraft.bamboo_hanging_sign": "Bamboehangbord",
  "block.minecraft.bamboo_mosaic": "Bamboemozaïek",
  "block.minecraft.bamboo_mosaic_slab": "Bamboemozaïekplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboemozaïektrap",
  "block.minecraft.bamboo_planks": "Bamboeplanken",
  "block.minecraft.bamboo_pressure_plate": "Bamboedrukplaat",
  "block.minecraft.bamboo_sapling": "Bamboescheut",
  "block.minecraft.bamboo_shelf": "Bamboeschap",
  "block.minecraft.bamboo_sign": "Bamboebord",
  "block.minecraft.bamboo_slab": "Bamboeplaat",
  "block.minecraft.bamboo_stairs": "Bamboetrap",
  "block.minecraft.bamboo_trapdoor": "Bamboevalluik",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboe-uithangbord",
  "block.minecraft.bamboo_wall_sign": "Bamboebord aan muur",
  "block.minecraft.banner.base.black": "Zwart veld",
  "block.minecraft.banner.base.blue": "Blauw veld",
  "block.minecraft.banner.base.brown": "Bruin veld",
  "block.minecraft.banner.base.cyan": "Turquoise veld",
  "block.minecraft.banner.base.gray": "Grijs veld",
  "block.minecraft.banner.base.green": "Groen veld",
  "block.minecraft.banner.base.light_blue": "Lichtblauw veld",
  "block.minecraft.banner.base.light_gray": "Lichtgrijs veld",
  "block.minecraft.banner.base.lime": "Lichtgroen veld",
  "block.minecraft.banner.base.magenta": "Magenta veld",
  "block.minecraft.banner.base.orange": "Oranje veld",
  "block.minecraft.banner.base.pink": "Roze veld",
  "block.minecraft.banner.base.purple": "Paars veld",
  "block.minecraft.banner.base.red": "Rood veld",
  "block.minecraft.banner.base.white": "Wit veld",
  "block.minecraft.banner.base.yellow": "Geel veld",
  "block.minecraft.banner.border.black": "Zwarte zoom",
  "block.minecraft.banner.border.blue": "Blauwe zoom",
  "block.minecraft.banner.border.brown": "Bruine zoom",
  "block.minecraft.banner.border.cyan": "Turquoise zoom",
  "block.minecraft.banner.border.gray": "Grijze zoom",
  "block.minecraft.banner.border.green": "Groene zoom",
  "block.minecraft.banner.border.light_blue": "Lichtblauwe zoom",
  "block.minecraft.banner.border.light_gray": "Lichtgrijze zoom",
  "block.minecraft.banner.border.lime": "Lichtgroene zoom",
  "block.minecraft.banner.border.magenta": "Magenta zoom",
  "block.minecraft.banner.border.orange": "Oranje zoom",
  "block.minecraft.banner.border.pink": "Roze zoom",
  "block.minecraft.banner.border.purple": "Paarse zoom",
  "block.minecraft.banner.border.red": "Rode zoom",
  "block.minecraft.banner.border.white": "Witte zoom",
  "block.minecraft.banner.border.yellow": "Gele zoom",
  "block.minecraft.banner.bricks.black": "Zwart metselwerk",
  "block.minecraft.banner.bricks.blue": "Blauw metselwerk",
  "block.minecraft.banner.bricks.brown": "Bruin metselwerk",
  "block.minecraft.banner.bricks.cyan": "Turquoise metselwerk",
  "block.minecraft.banner.bricks.gray": "Grijs metselwerk",
  "block.minecraft.banner.bricks.green": "Groen metselwerk",
  "block.minecraft.banner.bricks.light_blue": "Lichtblauw metselwerk",
  "block.minecraft.banner.bricks.light_gray": "Lichtgrijs metselwerk",
  "block.minecraft.banner.bricks.lime": "Lichtgroen metselwerk",
  "block.minecraft.banner.bricks.magenta": "Magenta metselwerk",
  "block.minecraft.banner.bricks.orange": "Oranje metselwerk",
  "block.minecraft.banner.bricks.pink": "Roze metselwerk",
  "block.minecraft.banner.bricks.purple": "Paars metselwerk",
  "block.minecraft.banner.bricks.red": "Rood metselwerk",
  "block.minecraft.banner.bricks.white": "Wit metselwerk",
  "block.minecraft.banner.bricks.yellow": "Geel metselwerk",
  "block.minecraft.banner.circle.black": "Zwarte koek",
  "block.minecraft.banner.circle.blue": "Blauwe koek",
  "block.minecraft.banner.circle.brown": "Bruine koek",
  "block.minecraft.banner.circle.cyan": "Turquoise koek",
  "block.minecraft.banner.circle.gray": "Grijze koek",
  "block.minecraft.banner.circle.green": "Groene koek",
  "block.minecraft.banner.circle.light_blue": "Lichtblauwe koek",
  "block.minecraft.banner.circle.light_gray": "Lichtgrijze koek",
  "block.minecraft.banner.circle.lime": "Lichtgroene koek",
  "block.minecraft.banner.circle.magenta": "Magenta koek",
  "block.minecraft.banner.circle.orange": "Oranje koek",
  "block.minecraft.banner.circle.pink": "Roze koek",
  "block.minecraft.banner.circle.purple": "Paarse koek",
  "block.minecraft.banner.circle.red": "Rode koek",
  "block.minecraft.banner.circle.white": "Witte koek",
  "block.minecraft.banner.circle.yellow": "Gele koek",
  "block.minecraft.banner.creeper.black": "Zwarte Creeper",
  "block.minecraft.banner.creeper.blue": "Blauwe Creeper",
  "block.minecraft.banner.creeper.brown": "Bruine Creeper",
  "block.minecraft.banner.creeper.cyan": "Turquoise Creeper",
  "block.minecraft.banner.creeper.gray": "Grijze Creeper",
  "block.minecraft.banner.creeper.green": "Groene Creeper",
  "block.minecraft.banner.creeper.light_blue": "Lichtblauwe Creeper",
  "block.minecraft.banner.creeper.light_gray": "Lichtgrijze Creeper",
  "block.minecraft.banner.creeper.lime": "Lichtgroene Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper",
  "block.minecraft.banner.creeper.orange": "Oranje Creeper",
  "block.minecraft.banner.creeper.pink": "Roze Creeper",
  "block.minecraft.banner.creeper.purple": "Paarse Creeper",
  "block.minecraft.banner.creeper.red": "Rode Creeper",
  "block.minecraft.banner.creeper.white": "Witte Creeper",
  "block.minecraft.banner.creeper.yellow": "Gele Creeper",
  "block.minecraft.banner.cross.black": "Zwart andreaskruis",
  "block.minecraft.banner.cross.blue": "Blauw andreaskruis",
  "block.minecraft.banner.cross.brown": "Bruin andreaskruis",
  "block.minecraft.banner.cross.cyan": "Turquoise andreaskruis",
  "block.minecraft.banner.cross.gray": "Grijs andreaskruis",
  "block.minecraft.banner.cross.green": "Groen andreaskruis",
  "block.minecraft.banner.cross.light_blue": "Lichtblauw andreaskruis",
  "block.minecraft.banner.cross.light_gray": "Lichtgrijs andreaskruis",
  "block.minecraft.banner.cross.lime": "Lichtgroen andreaskruis",
  "block.minecraft.banner.cross.magenta": "Magenta andreaskruis",
  "block.minecraft.banner.cross.orange": "Oranje andreaskruis",
  "block.minecraft.banner.cross.pink": "Roze andreaskruis",
  "block.minecraft.banner.cross.purple": "Paars andreaskruis",
  "block.minecraft.banner.cross.red": "Rood andreaskruis",
  "block.minecraft.banner.cross.white": "Wit andreaskruis",
  "block.minecraft.banner.cross.yellow": "Geel andreaskruis",
  "block.minecraft.banner.curly_border.black": "Zwarte ingesprongen zoom",
  "block.minecraft.banner.curly_border.blue": "Blauwe ingesprongen zoom",
  "block.minecraft.banner.curly_border.brown": "Bruine ingesprongen zoom",
  "block.minecraft.banner.curly_border.cyan": "Turquoise ingesprongen zoom",
  "block.minecraft.banner.curly_border.gray": "Grijze ingesprongen zoom",
  "block.minecraft.banner.curly_border.green": "Groene ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_blue": "Lichtblauwe ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_gray": "Lichtgrijze ingesprongen zoom",
  "block.minecraft.banner.curly_border.lime": "Lichtgroene ingesprongen zoom",
  "block.minecraft.banner.curly_border.magenta": "Magenta ingesprongen zoom",
  "block.minecraft.banner.curly_border.orange": "Oranje ingesprongen zoom",
  "block.minecraft.banner.curly_border.pink": "Roze ingesprongen zoom",
  "block.minecraft.banner.curly_border.purple": "Paarse ingesprongen zoom",
  "block.minecraft.banner.curly_border.red": "Rode ingesprongen zoom",
  "block.minecraft.banner.curly_border.white": "Witte ingesprongen zoom",
  "block.minecraft.banner.curly_border.yellow": "Gele ingesprongen zoom",
  "block.minecraft.banner.diagonal_left.black": "Zwart schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.blue": "Blauw schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.brown": "Bruin schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.cyan": "Turquoise schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.gray": "Grijs schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.green": "Groen schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.light_blue": "Lichtblauw schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.light_gray": "Lichtgrijs schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.lime": "Lichtgroen schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.orange": "Oranje schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.pink": "Roze schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.purple": "Paars schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.red": "Rood schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.white": "Wit schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.yellow": "Geel schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_right.black": "Zwart schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.blue": "Blauw schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.brown": "Bruin schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.cyan": "Turquoise schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.gray": "Grijs schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.green": "Groen schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.light_blue": "Lichtblauw schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.light_gray": "Lichtgrijs schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.lime": "Lichtgroen schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.orange": "Oranje schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.pink": "Roze schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.purple": "Paars schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.red": "Rood schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.white": "Wit schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_right.yellow": "Geel schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.black": "Zwart omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.blue": "Blauw omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.brown": "Bruin omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turquoise omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.gray": "Grijs omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.green": "Groen omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lichtblauw omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Lichtgrijs omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.lime": "Lichtgroen omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranje omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.pink": "Roze omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.purple": "Paars omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.red": "Rood omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.white": "Wit omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.yellow": "Geel omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_right.black": "Zwart omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.blue": "Blauw omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruin omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turquoise omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.gray": "Grijs omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.green": "Groen omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lichtblauw omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Lichtgrijs omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.lime": "Lichtgroen omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranje omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.pink": "Roze omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.purple": "Paars omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.red": "Rood omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.white": "Wit omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.yellow": "Geel omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.flow.black": "Zwarte windstroming",
  "block.minecraft.banner.flow.blue": "Blauwe windstroming",
  "block.minecraft.banner.flow.brown": "Bruine windstroming",
  "block.minecraft.banner.flow.cyan": "Turquoise windstroming",
  "block.minecraft.banner.flow.gray": "Grijze windstroming",
  "block.minecraft.banner.flow.green": "Groene windstroming",
  "block.minecraft.banner.flow.light_blue": "Lichtblauwe windstroming",
  "block.minecraft.banner.flow.light_gray": "Lichtgrijze windstroming",
  "block.minecraft.banner.flow.lime": "Lichtgroene windstroming",
  "block.minecraft.banner.flow.magenta": "Magenta windstroming",
  "block.minecraft.banner.flow.orange": "Oranje windstroming",
  "block.minecraft.banner.flow.pink": "Roze windstroming",
  "block.minecraft.banner.flow.purple": "Paarse windstroming",
  "block.minecraft.banner.flow.red": "Rode windstroming",
  "block.minecraft.banner.flow.white": "Witte windstroming",
  "block.minecraft.banner.flow.yellow": "Gele windstroming",
  "block.minecraft.banner.flower.black": "Zwarte bloem",
  "block.minecraft.banner.flower.blue": "Blauwe bloem",
  "block.minecraft.banner.flower.brown": "Bruine bloem",
  "block.minecraft.banner.flower.cyan": "Turquoise bloem",
  "block.minecraft.banner.flower.gray": "Grijze bloem",
  "block.minecraft.banner.flower.green": "Groene bloem",
  "block.minecraft.banner.flower.light_blue": "Lichtblauwe bloem",
  "block.minecraft.banner.flower.light_gray": "Lichtgrijze bloem",
  "block.minecraft.banner.flower.lime": "Lichtgroene bloem",
  "block.minecraft.banner.flower.magenta": "Magenta bloem",
  "block.minecraft.banner.flower.orange": "Oranje bloem",
  "block.minecraft.banner.flower.pink": "Roze bloem",
  "block.minecraft.banner.flower.purple": "Paarse bloem",
  "block.minecraft.banner.flower.red": "Rode bloem",
  "block.minecraft.banner.flower.white": "Witte bloem",
  "block.minecraft.banner.flower.yellow": "Gele bloem",
  "block.minecraft.banner.globe.black": "Zwarte globe",
  "block.minecraft.banner.globe.blue": "Blauwe globe",
  "block.minecraft.banner.globe.brown": "Bruine globe",
  "block.minecraft.banner.globe.cyan": "Turquoise globe",
  "block.minecraft.banner.globe.gray": "Grijze globe",
  "block.minecraft.banner.globe.green": "Groene globe",
  "block.minecraft.banner.globe.light_blue": "Lichtblauwe globe",
  "block.minecraft.banner.globe.light_gray": "Lichtgrijze globe",
  "block.minecraft.banner.globe.lime": "Lichtgroene globe",
  "block.minecraft.banner.globe.magenta": "Magenta globe",
  "block.minecraft.banner.globe.orange": "Oranje globe",
  "block.minecraft.banner.globe.pink": "Roze globe",
  "block.minecraft.banner.globe.purple": "Paarse globe",
  "block.minecraft.banner.globe.red": "Rode globe",
  "block.minecraft.banner.globe.white": "Witte globe",
  "block.minecraft.banner.globe.yellow": "Gele globe",
  "block.minecraft.banner.gradient.black": "Zwart gradiënt",
  "block.minecraft.banner.gradient.blue": "Blauw gradiënt",
  "block.minecraft.banner.gradient.brown": "Bruin gradiënt",
  "block.minecraft.banner.gradient.cyan": "Turquoise gradiënt",
  "block.minecraft.banner.gradient.gray": "Grijs gradiënt",
  "block.minecraft.banner.gradient.green": "Groen gradiënt",
  "block.minecraft.banner.gradient.light_blue": "Lichtblauw gradiënt",
  "block.minecraft.banner.gradient.light_gray": "Lichtgrijs gradiënt",
  "block.minecraft.banner.gradient.lime": "Lichtgroen gradiënt",
  "block.minecraft.banner.gradient.magenta": "Magenta gradiënt",
  "block.minecraft.banner.gradient.orange": "Oranje gradiënt",
  "block.minecraft.banner.gradient.pink": "Roze gradiënt",
  "block.minecraft.banner.gradient.purple": "Paars gradiënt",
  "block.minecraft.banner.gradient.red": "Rood gradiënt",
  "block.minecraft.banner.gradient.white": "Wit gradiënt",
  "block.minecraft.banner.gradient.yellow": "Geel gradiënt",
  "block.minecraft.banner.gradient_up.black": "Zwart schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.blue": "Blauw schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.brown": "Bruin schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.cyan": "Turquoise schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.gray": "Grijs schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.green": "Groen schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.light_blue": "Lichtblauw schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.light_gray": "Lichtgrijs schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.lime": "Lichtgroen schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.magenta": "Magenta schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.orange": "Oranje schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.pink": "Roze schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.purple": "Paars schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.red": "Rood schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.white": "Wit schildvoetgradiënt",
  "block.minecraft.banner.gradient_up.yellow": "Geel schildvoetgradiënt",
  "block.minecraft.banner.guster.black": "Zwarte rukwind",
  "block.minecraft.banner.guster.blue": "Blauwe rukwind",
  "block.minecraft.banner.guster.brown": "Bruine rukwind",
  "block.minecraft.banner.guster.cyan": "Turquoise rukwind",
  "block.minecraft.banner.guster.gray": "Grijze rukwind",
  "block.minecraft.banner.guster.green": "Groene rukwind",
  "block.minecraft.banner.guster.light_blue": "Lichtblauwe rukwind",
  "block.minecraft.banner.guster.light_gray": "Lichtgrijze rukwind",
  "block.minecraft.banner.guster.lime": "Lichtgroene rukwind",
  "block.minecraft.banner.guster.magenta": "Magenta rukwind",
  "block.minecraft.banner.guster.orange": "Oranje rukwind",
  "block.minecraft.banner.guster.pink": "Roze rukwind",
  "block.minecraft.banner.guster.purple": "Paarse rukwind",
  "block.minecraft.banner.guster.red": "Rode rukwind",
  "block.minecraft.banner.guster.white": "Witte rukwind",
  "block.minecraft.banner.guster.yellow": "Gele rukwind",
  "block.minecraft.banner.half_horizontal.black": "Zwartgebalkt",
  "block.minecraft.banner.half_horizontal.blue": "Blauwgebalkt",
  "block.minecraft.banner.half_horizontal.brown": "Bruingebalkt",
  "block.minecraft.banner.half_horizontal.cyan": "Turquoisegebalkt",
  "block.minecraft.banner.half_horizontal.gray": "Grijsgebalkt",
  "block.minecraft.banner.half_horizontal.green": "Groengebalkt",
  "block.minecraft.banner.half_horizontal.light_blue": "Lichtblauwgebalkt",
  "block.minecraft.banner.half_horizontal.light_gray": "Lichtgrijsgebalkt",
  "block.minecraft.banner.half_horizontal.lime": "Lichtgroengebalkt",
  "block.minecraft.banner.half_horizontal.magenta": "Magentagebalkt",
  "block.minecraft.banner.half_horizontal.orange": "Oranjegebalkt",
  "block.minecraft.banner.half_horizontal.pink": "Rozegebalkt",
  "block.minecraft.banner.half_horizontal.purple": "Paarsgebalkt",
  "block.minecraft.banner.half_horizontal.red": "Roodgebalkt",
  "block.minecraft.banner.half_horizontal.white": "Witgebalkt",
  "block.minecraft.banner.half_horizontal.yellow": "Geelgebalkt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Zwart omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blauw omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Bruin omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turquoise omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grijs omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Groen omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Lichtblauw omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Lichtgrijs omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lichtgroen omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranje omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roze omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Paars omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rood omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Wit omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Geel omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical.black": "Zwartgepaald",
  "block.minecraft.banner.half_vertical.blue": "Blauwgepaald",
  "block.minecraft.banner.half_vertical.brown": "Bruingepaald",
  "block.minecraft.banner.half_vertical.cyan": "Turquoisegepaald",
  "block.minecraft.banner.half_vertical.gray": "Grijsgepaald",
  "block.minecraft.banner.half_vertical.green": "Groengepaald",
  "block.minecraft.banner.half_vertical.light_blue": "Lichtblauwgepaald",
  "block.minecraft.banner.half_vertical.light_gray": "Lichtgrijsgepaald",
  "block.minecraft.banner.half_vertical.lime": "Lichtgroengepaald",
  "block.minecraft.banner.half_vertical.magenta": "Magentagepaald",
  "block.minecraft.banner.half_vertical.orange": "Oranjegepaald",
  "block.minecraft.banner.half_vertical.pink": "Rozegepaald",
  "block.minecraft.banner.half_vertical.purple": "Paarsgepaald",
  "block.minecraft.banner.half_vertical.red": "Roodgepaald",
  "block.minecraft.banner.half_vertical.white": "Witgepaald",
  "block.minecraft.banner.half_vertical.yellow": "Geelgepaald",
  "block.minecraft.banner.half_vertical_right.black": "Zwart omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.blue": "Blauw omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.brown": "Bruin omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.cyan": "Turquoise omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.gray": "Grijs omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.green": "Groen omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lichtblauw omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lichtgrijs omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.lime": "Lichtgroen omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.orange": "Oranje omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.pink": "Roze omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.purple": "Paars omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.red": "Rood omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.white": "Wit omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.yellow": "Geel omgekeerd gepaald",
  "block.minecraft.banner.mojang.black": "Zwart Mojanglogo",
  "block.minecraft.banner.mojang.blue": "Blauw Mojanglogo",
  "block.minecraft.banner.mojang.brown": "Bruin Mojanglogo",
  "block.minecraft.banner.mojang.cyan": "Turquoise Mojanglogo",
  "block.minecraft.banner.mojang.gray": "Grijs Mojanglogo",
  "block.minecraft.banner.mojang.green": "Groen Mojanglogo",
  "block.minecraft.banner.mojang.light_blue": "Lichtblauw Mojanglogo",
  "block.minecraft.banner.mojang.light_gray": "Lichtgrijs Mojanglogo",
  "block.minecraft.banner.mojang.lime": "Lichtgroen Mojanglogo",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojanglogo",
  "block.minecraft.banner.mojang.orange": "Oranje Mojanglogo",
  "block.minecraft.banner.mojang.pink": "Roze Mojanglogo",
  "block.minecraft.banner.mojang.purple": "Paars Mojanglogo",
  "block.minecraft.banner.mojang.red": "Rood Mojanglogo",
  "block.minecraft.banner.mojang.white": "Wit Mojanglogo",
  "block.minecraft.banner.mojang.yellow": "Geel Mojanglogo",
  "block.minecraft.banner.piglin.black": "Zwarte snuit",
  "block.minecraft.banner.piglin.blue": "Blauwe snuit",
  "block.minecraft.banner.piglin.brown": "Bruine snuit",
  "block.minecraft.banner.piglin.cyan": "Turquoise snuit",
  "block.minecraft.banner.piglin.gray": "Grijze snuit",
  "block.minecraft.banner.piglin.green": "Groene snuit",
  "block.minecraft.banner.piglin.light_blue": "Lichtblauwe snuit",
  "block.minecraft.banner.piglin.light_gray": "Lichtgrijze snuit",
  "block.minecraft.banner.piglin.lime": "Lichtgroene snuit",
  "block.minecraft.banner.piglin.magenta": "Magenta snuit",
  "block.minecraft.banner.piglin.orange": "Oranje snuit",
  "block.minecraft.banner.piglin.pink": "Roze snuit",
  "block.minecraft.banner.piglin.purple": "Paarse snuit",
  "block.minecraft.banner.piglin.red": "Rode snuit",
  "block.minecraft.banner.piglin.white": "Witte snuit",
  "block.minecraft.banner.piglin.yellow": "Gele snuit",
  "block.minecraft.banner.rhombus.black": "Zwart lozanje",
  "block.minecraft.banner.rhombus.blue": "Blauw lozanje",
  "block.minecraft.banner.rhombus.brown": "Bruin lozanje",
  "block.minecraft.banner.rhombus.cyan": "Turquoise lozanje",
  "block.minecraft.banner.rhombus.gray": "Grijs lozanje",
  "block.minecraft.banner.rhombus.green": "Groen lozanje",
  "block.minecraft.banner.rhombus.light_blue": "Lichtblauw lozanje",
  "block.minecraft.banner.rhombus.light_gray": "Lichtgrijs lozanje",
  "block.minecraft.banner.rhombus.lime": "Lichtgroen lozanje",
  "block.minecraft.banner.rhombus.magenta": "Magenta lozanje",
  "block.minecraft.banner.rhombus.orange": "Oranje lozanje",
  "block.minecraft.banner.rhombus.pink": "Roze lozanje",
  "block.minecraft.banner.rhombus.purple": "Paars lozanje",
  "block.minecraft.banner.rhombus.red": "Rood lozanje",
  "block.minecraft.banner.rhombus.white": "Wit lozanje",
  "block.minecraft.banner.rhombus.yellow": "Geel lozanje",
  "block.minecraft.banner.skull.black": "Zwarte schedel",
  "block.minecraft.banner.skull.blue": "Blauwe schedel",
  "block.minecraft.banner.skull.brown": "Bruine schedel",
  "block.minecraft.banner.skull.cyan": "Turquoise schedel",
  "block.minecraft.banner.skull.gray": "Grijze schedel",
  "block.minecraft.banner.skull.green": "Groene schedel",
  "block.minecraft.banner.skull.light_blue": "Lichtblauwe schedel",
  "block.minecraft.banner.skull.light_gray": "Lichtgrijze schedel",
  "block.minecraft.banner.skull.lime": "Lichtgroene schedel",
  "block.minecraft.banner.skull.magenta": "Magenta schedel",
  "block.minecraft.banner.skull.orange": "Oranje schedel",
  "block.minecraft.banner.skull.pink": "Roze schedel",
  "block.minecraft.banner.skull.purple": "Paarse schedel",
  "block.minecraft.banner.skull.red": "Rode schedel",
  "block.minecraft.banner.skull.white": "Witte schedel",
  "block.minecraft.banner.skull.yellow": "Gele schedel",
  "block.minecraft.banner.small_stripes.black": "Zwarte palen",
  "block.minecraft.banner.small_stripes.blue": "Blauwe palen",
  "block.minecraft.banner.small_stripes.brown": "Bruine palen",
  "block.minecraft.banner.small_stripes.cyan": "Turquoise palen",
  "block.minecraft.banner.small_stripes.gray": "Grijze palen",
  "block.minecraft.banner.small_stripes.green": "Groene palen",
  "block.minecraft.banner.small_stripes.light_blue": "Lichtblauwe palen",
  "block.minecraft.banner.small_stripes.light_gray": "Lichtgrijze palen",
  "block.minecraft.banner.small_stripes.lime": "Lichtgroene palen",
  "block.minecraft.banner.small_stripes.magenta": "Magenta palen",
  "block.minecraft.banner.small_stripes.orange": "Oranje palen",
  "block.minecraft.banner.small_stripes.pink": "Roze palen",
  "block.minecraft.banner.small_stripes.purple": "Paarse palen",
  "block.minecraft.banner.small_stripes.red": "Rode palen",
  "block.minecraft.banner.small_stripes.white": "Witte palen",
  "block.minecraft.banner.small_stripes.yellow": "Gele palen",
  "block.minecraft.banner.square_bottom_left.black": "Zwart kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.blue": "Blauw kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.brown": "Bruin kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.cyan": "Turquoise kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.gray": "Grijs kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.green": "Groen kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.light_blue": "Lichtblauw kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.light_gray": "Lichtgrijs kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.lime": "Lichtgroen kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.orange": "Oranje kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.pink": "Roze kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.purple": "Paars kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.red": "Rood kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.white": "Wit kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.yellow": "Geel kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_right.black": "Zwart kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.blue": "Blauw kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.brown": "Bruin kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.cyan": "Turquoise kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.gray": "Grijs kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.green": "Groen kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.light_blue": "Lichtblauw kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.light_gray": "Lichtgrijs kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.lime": "Lichtgroen kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.orange": "Oranje kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.pink": "Roze kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.purple": "Paars kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.red": "Rood kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.white": "Wit kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.yellow": "Geel kwartier linksonder",
  "block.minecraft.banner.square_top_left.black": "Zwart kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.blue": "Blauw kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.brown": "Bruin kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.cyan": "Turquoise kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.gray": "Grijs kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.green": "Groen kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.light_blue": "Lichtblauw kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.light_gray": "Lichtgrijs kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.lime": "Lichtgroen kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.magenta": "Magenta kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.orange": "Oranje kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.pink": "Roze kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.purple": "Paars kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.red": "Rood kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.white": "Wit kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.yellow": "Geel kwartier rechtsboven",
  "block.minecraft.banner.square_top_right.black": "Zwart kwartier linksboven",
  "block.minecraft.banner.square_top_right.blue": "Blauw kwartier linksboven",
  "block.minecraft.banner.square_top_right.brown": "Bruin kwartier linksboven",
  "block.minecraft.banner.square_top_right.cyan": "Turquoise kwartier linksboven",
  "block.minecraft.banner.square_top_right.gray": "Grijs kwartier linksboven",
  "block.minecraft.banner.square_top_right.green": "Groen kwartier linksboven",
  "block.minecraft.banner.square_top_right.light_blue": "Lichtblauw kwartier linksboven",
  "block.minecraft.banner.square_top_right.light_gray": "Lichtgrijs kwartier linksboven",
  "block.minecraft.banner.square_top_right.lime": "Lichtgroen kwartier linksboven",
  "block.minecraft.banner.square_top_right.magenta": "Magenta kwartier linksboven",
  "block.minecraft.banner.square_top_right.orange": "Oranje kwartier linksboven",
  "block.minecraft.banner.square_top_right.pink": "Roze kwartier linksboven",
  "block.minecraft.banner.square_top_right.purple": "Paars kwartier linksboven",
  "block.minecraft.banner.square_top_right.red": "Rood kwartier linksboven",
  "block.minecraft.banner.square_top_right.white": "Wit kwartier linksboven",
  "block.minecraft.banner.square_top_right.yellow": "Geel kwartier linksboven",
  "block.minecraft.banner.straight_cross.black": "Zwart kruis",
  "block.minecraft.banner.straight_cross.blue": "Blauw kruis",
  "block.minecraft.banner.straight_cross.brown": "Bruin kruis",
  "block.minecraft.banner.straight_cross.cyan": "Turquoise kruis",
  "block.minecraft.banner.straight_cross.gray": "Grijs kruis",
  "block.minecraft.banner.straight_cross.green": "Groen kruis",
  "block.minecraft.banner.straight_cross.light_blue": "Lichtblauw kruis",
  "block.minecraft.banner.straight_cross.light_gray": "Lichtgrijs kruis",
  "block.minecraft.banner.straight_cross.lime": "Lichtgroen kruis",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kruis",
  "block.minecraft.banner.straight_cross.orange": "Oranje kruis",
  "block.minecraft.banner.straight_cross.pink": "Roze kruis",
  "block.minecraft.banner.straight_cross.purple": "Paars kruis",
  "block.minecraft.banner.straight_cross.red": "Rood kruis",
  "block.minecraft.banner.straight_cross.white": "Wit kruis",
  "block.minecraft.banner.straight_cross.yellow": "Geel kruis",
  "block.minecraft.banner.stripe_bottom.black": "Zwart schildvoet",
  "block.minecraft.banner.stripe_bottom.blue": "Blauw schildvoet",
  "block.minecraft.banner.stripe_bottom.brown": "Bruin schildvoet",
  "block.minecraft.banner.stripe_bottom.cyan": "Turquoise schildvoet",
  "block.minecraft.banner.stripe_bottom.gray": "Grijs schildvoet",
  "block.minecraft.banner.stripe_bottom.green": "Groen schildvoet",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lichtblauw schildvoet",
  "block.minecraft.banner.stripe_bottom.light_gray": "Lichtgrijs schildvoet",
  "block.minecraft.banner.stripe_bottom.lime": "Lichtgroen schildvoet",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta schildvoet",
  "block.minecraft.banner.stripe_bottom.orange": "Oranje schildvoet",
  "block.minecraft.banner.stripe_bottom.pink": "Roze schildvoet",
  "block.minecraft.banner.stripe_bottom.purple": "Paars schildvoet",
  "block.minecraft.banner.stripe_bottom.red": "Rood schildvoet",
  "block.minecraft.banner.stripe_bottom.white": "Wit schildvoet",
  "block.minecraft.banner.stripe_bottom.yellow": "Geel schildvoet",
  "block.minecraft.banner.stripe_center.black": "Zwarte paal",
  "block.minecraft.banner.stripe_center.blue": "Blauwe paal",
  "block.minecraft.banner.stripe_center.brown": "Bruine paal",
  "block.minecraft.banner.stripe_center.cyan": "Turquoise paal",
  "block.minecraft.banner.stripe_center.gray": "Grijze paal",
  "block.minecraft.banner.stripe_center.green": "Groene paal",
  "block.minecraft.banner.stripe_center.light_blue": "Lichtblauwe paal",
  "block.minecraft.banner.stripe_center.light_gray": "Lichtgrijze paal",
  "block.minecraft.banner.stripe_center.lime": "Lichtgroene paal",
  "block.minecraft.banner.stripe_center.magenta": "Magenta paal",
  "block.minecraft.banner.stripe_center.orange": "Oranje paal",
  "block.minecraft.banner.stripe_center.pink": "Roze paal",
  "block.minecraft.banner.stripe_center.purple": "Paarse paal",
  "block.minecraft.banner.stripe_center.red": "Rode paal",
  "block.minecraft.banner.stripe_center.white": "Witte paal",
  "block.minecraft.banner.stripe_center.yellow": "Gele paal",
  "block.minecraft.banner.stripe_downleft.black": "Zwarte linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.blue": "Blauwe linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.brown": "Bruine linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.cyan": "Turquoise linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.gray": "Grijze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.green": "Groene linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.light_blue": "Lichtblauwe linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.light_gray": "Lichtgrijze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.lime": "Lichtgroene linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.orange": "Oranje linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.pink": "Roze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.purple": "Paarse linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.red": "Rode linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.white": "Witte linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.yellow": "Gele linkerschuinbalk",
  "block.minecraft.banner.stripe_downright.black": "Zwarte rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.blue": "Blauwe rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.brown": "Bruine rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.cyan": "Turquoise rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.gray": "Grijze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.green": "Groene rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.light_blue": "Lichtblauwe rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.light_gray": "Lichtgrijze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.lime": "Lichtgroene rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.orange": "Oranje rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.pink": "Roze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.purple": "Paarse rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.red": "Rode rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.white": "Witte rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.yellow": "Gele rechterschuinbalk",
  "block.minecraft.banner.stripe_left.black": "Zwarte rechterpaal",
  "block.minecraft.banner.stripe_left.blue": "Blauwe rechterpaal",
  "block.minecraft.banner.stripe_left.brown": "Bruine rechterpaal",
  "block.minecraft.banner.stripe_left.cyan": "Turquoise rechterpaal",
  "block.minecraft.banner.stripe_left.gray": "Grijze rechterpaal",
  "block.minecraft.banner.stripe_left.green": "Groene rechterpaal",
  "block.minecraft.banner.stripe_left.light_blue": "Lichtblauwe rechterpaal",
  "block.minecraft.banner.stripe_left.light_gray": "Lichtgrijze rechterpaal",
  "block.minecraft.banner.stripe_left.lime": "Lichtgroene rechterpaal",
  "block.minecraft.banner.stripe_left.magenta": "Magenta rechterpaal",
  "block.minecraft.banner.stripe_left.orange": "Oranje rechterpaal",
  "block.minecraft.banner.stripe_left.pink": "Roze rechterpaal",
  "block.minecraft.banner.stripe_left.purple": "Paarse rechterpaal",
  "block.minecraft.banner.stripe_left.red": "Rode rechterpaal",
  "block.minecraft.banner.stripe_left.white": "Witte rechterpaal",
  "block.minecraft.banner.stripe_left.yellow": "Gele rechterpaal",
  "block.minecraft.banner.stripe_middle.black": "Zwarte dwarsbalk",
  "block.minecraft.banner.stripe_middle.blue": "Blauwe dwarsbalk",
  "block.minecraft.banner.stripe_middle.brown": "Bruine dwarsbalk",
  "block.minecraft.banner.stripe_middle.cyan": "Turquoise dwarsbalk",
  "block.minecraft.banner.stripe_middle.gray": "Grijze dwarsbalk",
  "block.minecraft.banner.stripe_middle.green": "Groene dwarsbalk",
  "block.minecraft.banner.stripe_middle.light_blue": "Lichtblauwe dwarsbalk",
  "block.minecraft.banner.stripe_middle.light_gray": "Lichtgrijze dwarsbalk",
  "block.minecraft.banner.stripe_middle.lime": "Lichtgroene dwarsbalk",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta dwarsbalk",
  "block.minecraft.banner.stripe_middle.orange": "Oranje dwarsbalk",
  "block.minecraft.banner.stripe_middle.pink": "Roze dwarsbalk",
  "block.minecraft.banner.stripe_middle.purple": "Paarse dwarsbalk",
  "block.minecraft.banner.stripe_middle.red": "Rode dwarsbalk",
  "block.minecraft.banner.stripe_middle.white": "Witte dwarsbalk",
  "block.minecraft.banner.stripe_middle.yellow": "Gele dwarsbalk",
  "block.minecraft.banner.stripe_right.black": "Zwarte linkerpaal",
  "block.minecraft.banner.stripe_right.blue": "Blauwe linkerpaal",
  "block.minecraft.banner.stripe_right.brown": "Bruine linkerpaal",
  "block.minecraft.banner.stripe_right.cyan": "Turquoise linkerpaal",
  "block.minecraft.banner.stripe_right.gray": "Grijze linkerpaal",
  "block.minecraft.banner.stripe_right.green": "Groene linkerpaal",
  "block.minecraft.banner.stripe_right.light_blue": "Lichtblauwe linkerpaal",
  "block.minecraft.banner.stripe_right.light_gray": "Lichtgrijze linkerpaal",
  "block.minecraft.banner.stripe_right.lime": "Lichtgroene linkerpaal",
  "block.minecraft.banner.stripe_right.magenta": "Magenta linkerpaal",
  "block.minecraft.banner.stripe_right.orange": "Oranje linkerpaal",
  "block.minecraft.banner.stripe_right.pink": "Roze linkerpaal",
  "block.minecraft.banner.stripe_right.purple": "Paarse linkerpaal",
  "block.minecraft.banner.stripe_right.red": "Rode linkerpaal",
  "block.minecraft.banner.stripe_right.white": "Witte linkerpaal",
  "block.minecraft.banner.stripe_right.yellow": "Gele linkerpaal",
  "block.minecraft.banner.stripe_top.black": "Zwart schildhoofd",
  "block.minecraft.banner.stripe_top.blue": "Blauw schildhoofd",
  "block.minecraft.banner.stripe_top.brown": "Bruin schildhoofd",
  "block.minecraft.banner.stripe_top.cyan": "Turquoise schildhoofd",
  "block.minecraft.banner.stripe_top.gray": "Grijs schildhoofd",
  "block.minecraft.banner.stripe_top.green": "Groen schildhoofd",
  "block.minecraft.banner.stripe_top.light_blue": "Lichtblauw schildhoofd",
  "block.minecraft.banner.stripe_top.light_gray": "Lichtgrijs schildhoofd",
  "block.minecraft.banner.stripe_top.lime": "Lichtgroen schildhoofd",
  "block.minecraft.banner.stripe_top.magenta": "Magenta schildhoofd",
  "block.minecraft.banner.stripe_top.orange": "Oranje schildhoofd",
  "block.minecraft.banner.stripe_top.pink": "Roze schildhoofd",
  "block.minecraft.banner.stripe_top.purple": "Paars schildhoofd",
  "block.minecraft.banner.stripe_top.red": "Rood schildhoofd",
  "block.minecraft.banner.stripe_top.white": "Wit schildhoofd",
  "block.minecraft.banner.stripe_top.yellow": "Geel schildhoofd",
  "block.minecraft.banner.triangle_bottom.black": "Zwarte keper",
  "block.minecraft.banner.triangle_bottom.blue": "Blauwe keper",
  "block.minecraft.banner.triangle_bottom.brown": "Bruine keper",
  "block.minecraft.banner.triangle_bottom.cyan": "Turquoise keper",
  "block.minecraft.banner.triangle_bottom.gray": "Grijze keper",
  "block.minecraft.banner.triangle_bottom.green": "Groene keper",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lichtblauwe keper",
  "block.minecraft.banner.triangle_bottom.light_gray": "Lichtgrijze keper",
  "block.minecraft.banner.triangle_bottom.lime": "Lichtgroene keper",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta keper",
  "block.minecraft.banner.triangle_bottom.orange": "Oranje keper",
  "block.minecraft.banner.triangle_bottom.pink": "Roze keper",
  "block.minecraft.banner.triangle_bottom.purple": "Paarse keper",
  "block.minecraft.banner.triangle_bottom.red": "Rode keper",
  "block.minecraft.banner.triangle_bottom.white": "Witte keper",
  "block.minecraft.banner.triangle_bottom.yellow": "Gele keper",
  "block.minecraft.banner.triangle_top.black": "Zwarte omgekeerde keper",
  "block.minecraft.banner.triangle_top.blue": "Blauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.brown": "Bruine omgekeerde keper",
  "block.minecraft.banner.triangle_top.cyan": "Turquoise omgekeerde keper",
  "block.minecraft.banner.triangle_top.gray": "Grijze omgekeerde keper",
  "block.minecraft.banner.triangle_top.green": "Groene omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_blue": "Lichtblauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_gray": "Lichtgrijze omgekeerde keper",
  "block.minecraft.banner.triangle_top.lime": "Lichtgroene omgekeerde keper",
  "block.minecraft.banner.triangle_top.magenta": "Magenta omgekeerde keper",
  "block.minecraft.banner.triangle_top.orange": "Oranje omgekeerde keper",
  "block.minecraft.banner.triangle_top.pink": "Roze omgekeerde keper",
  "block.minecraft.banner.triangle_top.purple": "Paarse omgekeerde keper",
  "block.minecraft.banner.triangle_top.red": "Rode omgekeerde keper",
  "block.minecraft.banner.triangle_top.white": "Witte omgekeerde keper",
  "block.minecraft.banner.triangle_top.yellow": "Gele omgekeerde keper",
  "block.minecraft.banner.triangles_bottom.black": "Zwartgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.blue": "Blauwgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.brown": "Bruingegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.cyan": "Turquoisegegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.gray": "Grijsgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.green": "Groengegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.light_blue": "Lichtblauwgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.light_gray": "Lichtgrijsgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.lime": "Lichtgroengegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.magenta": "Magentagegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.orange": "Oranjegegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.pink": "Rozegegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.purple": "Paarsgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.red": "Roodgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.white": "Witgegolfd schildvoet",
  "block.minecraft.banner.triangles_bottom.yellow": "Geelgegolfd schildvoet",
  "block.minecraft.banner.triangles_top.black": "Zwartgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.blue": "Blauwgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.brown": "Bruingegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.cyan": "Turquoisegegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.gray": "Grijsgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.green": "Groengegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.light_blue": "Lichtblauwgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.light_gray": "Lichtgrijsgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.lime": "Lichtgroengegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.magenta": "Magentagegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.orange": "Oranjegegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.pink": "Rozegegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.purple": "Paarsgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.red": "Roodgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.white": "Witgegolfd schildhoofd",
  "block.minecraft.banner.triangles_top.yellow": "Geelgegolfd schildhoofd",
  "block.minecraft.barrel": "Vat",
  "block.minecraft.barrier": "Barrière",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Baken",
  "block.minecraft.beacon.primary": "Primaire kracht",
  "block.minecraft.beacon.secondary": "Secundaire kracht",
  "block.minecraft.bed.no_sleep": "Je kunt alleen 's nachts of tijdens onweer slapen",
  "block.minecraft.bed.not_safe": "Je kunt nu niet slapen; er zijn monsters in de buurt",
  "block.minecraft.bed.obstructed": "Dit bed wordt geblokkeerd",
  "block.minecraft.bed.occupied": "Dit bed is bezet",
  "block.minecraft.bed.too_far_away": "Je kunt nu niet slapen; het bed is te ver weg",
  "block.minecraft.bedrock": "Bodemsteen",
  "block.minecraft.bee_nest": "Bijennest",
  "block.minecraft.beehive": "Bijenkorf",
  "block.minecraft.beetroots": "Bieten",
  "block.minecraft.bell": "Bel",
  "block.minecraft.big_dripleaf": "Groot druipblad",
  "block.minecraft.big_dripleaf_stem": "Grote druipbladstengel",
  "block.minecraft.birch_button": "Berkenhouten knop",
  "block.minecraft.birch_door": "Berkenhouten deur",
  "block.minecraft.birch_fence": "Berkenhouten hek",
  "block.minecraft.birch_fence_gate": "Berkenhouten poort",
  "block.minecraft.birch_hanging_sign": "Berkenhouten hangbord",
  "block.minecraft.birch_leaves": "Berkenbladeren",
  "block.minecraft.birch_log": "Berkenstam",
  "block.minecraft.birch_planks": "Berkenhouten planken",
  "block.minecraft.birch_pressure_plate": "Berkenhouten drukplaat",
  "block.minecraft.birch_sapling": "Berkenzaailing",
  "block.minecraft.birch_shelf": "Berkenhouten schap",
  "block.minecraft.birch_sign": "Berkenhouten bord",
  "block.minecraft.birch_slab": "Berkenhouten plaat",
  "block.minecraft.birch_stairs": "Berkenhouten trap",
  "block.minecraft.birch_trapdoor": "Berkenhouten valluik",
  "block.minecraft.birch_wall_hanging_sign": "Berkenhouten uithangbord",
  "block.minecraft.birch_wall_sign": "Berkenhouten bord aan muur",
  "block.minecraft.birch_wood": "Berkenhout",
  "block.minecraft.black_banner": "Zwarte banier",
  "block.minecraft.black_bed": "Zwart bed",
  "block.minecraft.black_candle": "Zwarte kaars",
  "block.minecraft.black_candle_cake": "Taart met zwarte kaars",
  "block.minecraft.black_carpet": "Zwart tapijt",
  "block.minecraft.black_concrete": "Zwart beton",
  "block.minecraft.black_concrete_powder": "Zwart cement",
  "block.minecraft.black_glazed_terracotta": "Zwartgeglazuurd terracotta",
  "block.minecraft.black_shulker_box": "Zwarte Shulkerdoos",
  "block.minecraft.black_stained_glass": "Zwartgekleurd glas",
  "block.minecraft.black_stained_glass_pane": "Zwartgekleurde glazen ruit",
  "block.minecraft.black_terracotta": "Zwart terracotta",
  "block.minecraft.black_wool": "Zwarte wol",
  "block.minecraft.blackstone": "Zwartsteen",
  "block.minecraft.blackstone_slab": "Zwartstenen plaat",
  "block.minecraft.blackstone_stairs": "Zwartstenen trap",
  "block.minecraft.blackstone_wall": "Zwartstenen muur",
  "block.minecraft.blast_furnace": "Hoogoven",
  "block.minecraft.blue_banner": "Blauwe banier",
  "block.minecraft.blue_bed": "Blauw bed",
  "block.minecraft.blue_candle": "Blauwe kaars",
  "block.minecraft.blue_candle_cake": "Taart met blauwe kaars",
  "block.minecraft.blue_carpet": "Blauw tapijt",
  "block.minecraft.blue_concrete": "Blauw beton",
  "block.minecraft.blue_concrete_powder": "Blauw cement",
  "block.minecraft.blue_glazed_terracotta": "Blauwgeglazuurd terracotta",
  "block.minecraft.blue_ice": "Blauw ijs",
  "block.minecraft.blue_orchid": "Blauwe orchidee",
  "block.minecraft.blue_shulker_box": "Blauwe Shulkerdoos",
  "block.minecraft.blue_stained_glass": "Blauwgekleurd glas",
  "block.minecraft.blue_stained_glass_pane": "Blauwgekleurde glazen ruit",
  "block.minecraft.blue_terracotta": "Blauw terracotta",
  "block.minecraft.blue_wool": "Blauwe wol",
  "block.minecraft.bone_block": "Bottenblok",
  "block.minecraft.bookshelf": "Boekenkast",
  "block.minecraft.brain_coral": "Hersenkoraal",
  "block.minecraft.brain_coral_block": "Hersenkoraalblok",
  "block.minecraft.brain_coral_fan": "Hersenkoraalwaaier",
  "block.minecraft.brain_coral_wall_fan": "Hersenkoraalwaaier aan muur",
  "block.minecraft.brewing_stand": "Brouwstandaard",
  "block.minecraft.brick_slab": "Bakstenen plaat",
  "block.minecraft.brick_stairs": "Bakstenen trap",
  "block.minecraft.brick_wall": "Bakstenen muur",
  "block.minecraft.bricks": "Bakstenen",
  "block.minecraft.brown_banner": "Bruine banier",
  "block.minecraft.brown_bed": "Bruin bed",
  "block.minecraft.brown_candle": "Bruine kaars",
  "block.minecraft.brown_candle_cake": "Taart met bruine kaars",
  "block.minecraft.brown_carpet": "Bruin tapijt",
  "block.minecraft.brown_concrete": "Bruin beton",
  "block.minecraft.brown_concrete_powder": "Bruin cement",
  "block.minecraft.brown_glazed_terracotta": "Bruingeglazuurd terracotta",
  "block.minecraft.brown_mushroom": "Bruine paddenstoel",
  "block.minecraft.brown_mushroom_block": "Bruin paddenstoelenblok",
  "block.minecraft.brown_shulker_box": "Bruine Shulkerdoos",
  "block.minecraft.brown_stained_glass": "Bruingekleurd glas",
  "block.minecraft.brown_stained_glass_pane": "Bruingekleurde glazen ruit",
  "block.minecraft.brown_terracotta": "Bruin terracotta",
  "block.minecraft.brown_wool": "Bruine wol",
  "block.minecraft.bubble_column": "Bellenkolom",
  "block.minecraft.bubble_coral": "Blaaskoraal",
  "block.minecraft.bubble_coral_block": "Blaaskoraalblok",
  "block.minecraft.bubble_coral_fan": "Blaaskoraalwaaier",
  "block.minecraft.bubble_coral_wall_fan": "Blaaskoraalwaaier aan muur",
  "block.minecraft.budding_amethyst": "Uitlopende amethist",
  "block.minecraft.bush": "Struik",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Cactusbloem",
  "block.minecraft.cake": "Taart",
  "block.minecraft.calcite": "Calciet",
  "block.minecraft.calibrated_sculk_sensor": "Gekalibreerde sculksensor",
  "block.minecraft.campfire": "Kampvuur",
  "block.minecraft.candle": "Kaars",
  "block.minecraft.candle_cake": "Taart met kaars",
  "block.minecraft.carrots": "Wortels",
  "block.minecraft.cartography_table": "Kartografietafel",
  "block.minecraft.carved_pumpkin": "Bewerkte pompoen",
  "block.minecraft.cauldron": "Ketel",
  "block.minecraft.cave_air": "Grottenlucht",
  "block.minecraft.cave_vines": "Grottenlianen",
  "block.minecraft.cave_vines_plant": "Grottenlianenplant",
  "block.minecraft.chain": "Ketting",
  "block.minecraft.chain_command_block": "Gekoppeld opdrachtblok",
  "block.minecraft.cherry_button": "Kersenhouten knop",
  "block.minecraft.cherry_door": "Kersenhouten deur",
  "block.minecraft.cherry_fence": "Kersenhouten hek",
  "block.minecraft.cherry_fence_gate": "Kersenhouten poortje",
  "block.minecraft.cherry_hanging_sign": "Kersenhouten hangbord",
  "block.minecraft.cherry_leaves": "Kersenbladeren",
  "block.minecraft.cherry_log": "Kersenboomstam",
  "block.minecraft.cherry_planks": "Kersenhouten planken",
  "block.minecraft.cherry_pressure_plate": "Kersenhouten drukplaat",
  "block.minecraft.cherry_sapling": "Kersenzaailing",
  "block.minecraft.cherry_shelf": "Kersenhouten schap",
  "block.minecraft.cherry_sign": "Kersenhouten bord",
  "block.minecraft.cherry_slab": "Kersenhouten plaat",
  "block.minecraft.cherry_stairs": "Kersenhouten trap",
  "block.minecraft.cherry_trapdoor": "Kersenhouten valluik",
  "block.minecraft.cherry_wall_hanging_sign": "Kersenhouten uithangbord",
  "block.minecraft.cherry_wall_sign": "Kersenhouten bord aan muur",
  "block.minecraft.cherry_wood": "Kersenhout",
  "block.minecraft.chest": "Kist",
  "block.minecraft.chipped_anvil": "Gebarsten aambeeld",
  "block.minecraft.chiseled_bookshelf": "Bewerkte boekenkast",
  "block.minecraft.chiseled_copper": "Bewerkt koperblok",
  "block.minecraft.chiseled_deepslate": "Gebeiteld wrevelsteen",
  "block.minecraft.chiseled_nether_bricks": "Gebeitelde Netherbakstenen",
  "block.minecraft.chiseled_polished_blackstone": "Gebeiteld gepolijst zwartsteen",
  "block.minecraft.chiseled_quartz_block": "Gebeiteld kwartsblok",
  "block.minecraft.chiseled_red_sandstone": "Gebeiteld rood zandsteen",
  "block.minecraft.chiseled_resin_bricks": "Gebeitelde harsbakstenen",
  "block.minecraft.chiseled_sandstone": "Gebeiteld zandsteen",
  "block.minecraft.chiseled_stone_bricks": "Gebeitelde blokstenen",
  "block.minecraft.chiseled_tuff": "Gebeiteld tufsteen",
  "block.minecraft.chiseled_tuff_bricks": "Gebeitelde tufstenen blokstenen",
  "block.minecraft.chorus_flower": "Chorusbloem",
  "block.minecraft.chorus_plant": "Chorusplant",
  "block.minecraft.clay": "Klei",
  "block.minecraft.closed_eyeblossom": "Gesloten gluurbloesem",
  "block.minecraft.coal_block": "Steenkoolblok",
  "block.minecraft.coal_ore": "Steenkoolerts",
  "block.minecraft.coarse_dirt": "Grove aarde",
  "block.minecraft.cobbled_deepslate": "Geplaveid wrevelsteen",
  "block.minecraft.cobbled_deepslate_slab": "Geplaveide wrevelstenen plaat",
  "block.minecraft.cobbled_deepslate_stairs": "Geplaveide wrevelstenen trap",
  "block.minecraft.cobbled_deepslate_wall": "Geplaveide wrevelstenen muur",
  "block.minecraft.cobblestone": "Keisteen",
  "block.minecraft.cobblestone_slab": "Keistenen plaat",
  "block.minecraft.cobblestone_stairs": "Keistenen trap",
  "block.minecraft.cobblestone_wall": "Keistenen muur",
  "block.minecraft.cobweb": "Spinnenweb",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Opdrachtblok",
  "block.minecraft.comparator": "Redstonevergelijker",
  "block.minecraft.composter": "Compostbak",
  "block.minecraft.conduit": "Kracht van de zee",
  "block.minecraft.copper_bars": "Koperen tralies",
  "block.minecraft.copper_block": "Koperblok",
  "block.minecraft.copper_bulb": "Koperen lamp",
  "block.minecraft.copper_chain": "Koperen ketting",
  "block.minecraft.copper_chest": "Koperen kist",
  "block.minecraft.copper_door": "Koperen deur",
  "block.minecraft.copper_golem_statue": "Kopergolemstandbeeld",
  "block.minecraft.copper_grate": "Koperen rooster",
  "block.minecraft.copper_lantern": "Koperen lantaarn",
  "block.minecraft.copper_ore": "Kopererts",
  "block.minecraft.copper_torch": "Koperfakkel",
  "block.minecraft.copper_trapdoor": "Koperen valluik",
  "block.minecraft.copper_wall_torch": "Koperfakkel aan muur",
  "block.minecraft.cornflower": "Korenbloem",
  "block.minecraft.cracked_deepslate_bricks": "Gebarsten wrevelstenen blokstenen",
  "block.minecraft.cracked_deepslate_tiles": "Gebarsten wrevelstenen tegels",
  "block.minecraft.cracked_nether_bricks": "Gebarsten Netherbakstenen",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gebarsten gepolijste zwartstenen blokstenen",
  "block.minecraft.cracked_stone_bricks": "Gebarsten blokstenen",
  "block.minecraft.crafter": "Vervaardigingsmachine",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Schorswakerhart",
  "block.minecraft.creeper_head": "Creeperhoofd",
  "block.minecraft.creeper_wall_head": "Creeperhoofd aan muur",
  "block.minecraft.crimson_button": "Helrode houten knop",
  "block.minecraft.crimson_door": "Helrode houten deur",
  "block.minecraft.crimson_fence": "Helrood houten hek",
  "block.minecraft.crimson_fence_gate": "Helrode houten poort",
  "block.minecraft.crimson_fungus": "Helrode zwam",
  "block.minecraft.crimson_hanging_sign": "Helrood houten hangbord",
  "block.minecraft.crimson_hyphae": "Helrode schimmeldraden",
  "block.minecraft.crimson_nylium": "Helrood nylium",
  "block.minecraft.crimson_planks": "Helrode houten planken",
  "block.minecraft.crimson_pressure_plate": "Helrode houten drukplaat",
  "block.minecraft.crimson_roots": "Helrode wortels",
  "block.minecraft.crimson_shelf": "Helrood houten schap",
  "block.minecraft.crimson_sign": "Helrood houten bord",
  "block.minecraft.crimson_slab": "Helrode houten plaat",
  "block.minecraft.crimson_stairs": "Helrode houten trap",
  "block.minecraft.crimson_stem": "Helrode stam",
  "block.minecraft.crimson_trapdoor": "Helrood houten valluik",
  "block.minecraft.crimson_wall_hanging_sign": "Helrood houten uithangbord",
  "block.minecraft.crimson_wall_sign": "Helrood houten bord aan muur",
  "block.minecraft.crying_obsidian": "Huilend obsidiaan",
  "block.minecraft.cut_copper": "Gesneden koperblok",
  "block.minecraft.cut_copper_slab": "Gesneden koperen plaat",
  "block.minecraft.cut_copper_stairs": "Gesneden koperen trap",
  "block.minecraft.cut_red_sandstone": "Gesneden rood zandsteen",
  "block.minecraft.cut_red_sandstone_slab": "Gesneden rode zandstenen plaat",
  "block.minecraft.cut_sandstone": "Gesneden zandsteen",
  "block.minecraft.cut_sandstone_slab": "Gesneden zandstenen plaat",
  "block.minecraft.cyan_banner": "Turquoise banier",
  "block.minecraft.cyan_bed": "Turquoise bed",
  "block.minecraft.cyan_candle": "Turquoise kaars",
  "block.minecraft.cyan_candle_cake": "Taart met turquoise kaars",
  "block.minecraft.cyan_carpet": "Turquoise tapijt",
  "block.minecraft.cyan_concrete": "Turquoise beton",
  "block.minecraft.cyan_concrete_powder": "Turquoise cement",
  "block.minecraft.cyan_glazed_terracotta": "Turquoisegeglazuurd terracotta",
  "block.minecraft.cyan_shulker_box": "Turquoise Shulkerdoos",
  "block.minecraft.cyan_stained_glass": "Turquoisegekleurd glas",
  "block.minecraft.cyan_stained_glass_pane": "Turquoisegekleurde glazen ruit",
  "block.minecraft.cyan_terracotta": "Turquoise terracotta",
  "block.minecraft.cyan_wool": "Turquoise wol",
  "block.minecraft.damaged_anvil": "Beschadigd aambeeld",
  "block.minecraft.dandelion": "Paardenbloem",
  "block.minecraft.dark_oak_button": "Donkere eikenhouten knop",
  "block.minecraft.dark_oak_door": "Donkere eikenhouten deur",
  "block.minecraft.dark_oak_fence": "Donker eikenhouten hek",
  "block.minecraft.dark_oak_fence_gate": "Donkere eikenhouten poort",
  "block.minecraft.dark_oak_hanging_sign": "Donker eikenhouten hangbord",
  "block.minecraft.dark_oak_leaves": "Donkere eikenbladeren",
  "block.minecraft.dark_oak_log": "Donkere eikenstam",
  "block.minecraft.dark_oak_planks": "Donkere eikenhouten planken",
  "block.minecraft.dark_oak_pressure_plate": "Donkere eikenhouten drukplaat",
  "block.minecraft.dark_oak_sapling": "Donkere eikenzaailing",
  "block.minecraft.dark_oak_shelf": "Donker eikenhouten schap",
  "block.minecraft.dark_oak_sign": "Donker eikenhouten bord",
  "block.minecraft.dark_oak_slab": "Donkere eikenhouten plaat",
  "block.minecraft.dark_oak_stairs": "Donkere eikenhouten trap",
  "block.minecraft.dark_oak_trapdoor": "Donker eikenhouten valluik",
  "block.minecraft.dark_oak_wall_hanging_sign": "Donker eikenhouten uithangbord",
  "block.minecraft.dark_oak_wall_sign": "Donker eikenhouten bord aan muur",
  "block.minecraft.dark_oak_wood": "Donker eikenhout",
  "block.minecraft.dark_prismarine": "Donkerprismarien",
  "block.minecraft.dark_prismarine_slab": "Donkerprismarienplaat",
  "block.minecraft.dark_prismarine_stairs": "Donkerprismarientrap",
  "block.minecraft.daylight_detector": "Daglichtsensor",
  "block.minecraft.dead_brain_coral": "Dood hersenkoraal",
  "block.minecraft.dead_brain_coral_block": "Dood hersenkoraalblok",
  "block.minecraft.dead_brain_coral_fan": "Dode hersenkoraalwaaier",
  "block.minecraft.dead_brain_coral_wall_fan": "Dode hersenkoraalwaaier aan muur",
  "block.minecraft.dead_bubble_coral": "Dood blaaskoraal",
  "block.minecraft.dead_bubble_coral_block": "Dood blaaskoraalblok",
  "block.minecraft.dead_bubble_coral_fan": "Dode blaaskoraalwaaier",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dode blaaskoraalwaaier aan muur",
  "block.minecraft.dead_bush": "Dode struik",
  "block.minecraft.dead_fire_coral": "Dood brandkoraal",
  "block.minecraft.dead_fire_coral_block": "Dood brandkoraalblok",
  "block.minecraft.dead_fire_coral_fan": "Dode brandkoraalwaaier",
  "block.minecraft.dead_fire_coral_wall_fan": "Dode brandkoraalwaaier aan muur",
  "block.minecraft.dead_horn_coral": "Dood hoornkoraal",
  "block.minecraft.dead_horn_coral_block": "Dood hoornkoraalblok",
  "block.minecraft.dead_horn_coral_fan": "Dode hoornkoraalwaaier",
  "block.minecraft.dead_horn_coral_wall_fan": "Dode hoornkoraalwaaier aan muur",
  "block.minecraft.dead_tube_coral": "Dood buiskoraal",
  "block.minecraft.dead_tube_coral_block": "Dood buiskoraalblok",
  "block.minecraft.dead_tube_coral_fan": "Dode buiskoraalwaaier",
  "block.minecraft.dead_tube_coral_wall_fan": "Dode buiskoraalwaaier aan muur",
  "block.minecraft.decorated_pot": "Versierde pot",
  "block.minecraft.deepslate": "Wrevelsteen",
  "block.minecraft.deepslate_brick_slab": "Wrevelblokstenen plaat",
  "block.minecraft.deepslate_brick_stairs": "Wrevelblokstenen trap",
  "block.minecraft.deepslate_brick_wall": "Wrevelblokstenen muur",
  "block.minecraft.deepslate_bricks": "Wrevelstenen blokstenen",
  "block.minecraft.deepslate_coal_ore": "Wrevelsteen-steenkoolerts",
  "block.minecraft.deepslate_copper_ore": "Wrevelsteenkopererts",
  "block.minecraft.deepslate_diamond_ore": "Wrevelsteendiamanterts",
  "block.minecraft.deepslate_emerald_ore": "Wrevelsteensmaragderts",
  "block.minecraft.deepslate_gold_ore": "Wrevelsteengouderts",
  "block.minecraft.deepslate_iron_ore": "Wrevelsteenijzererts",
  "block.minecraft.deepslate_lapis_ore": "Wrevelsteenlapislazuli-erts",
  "block.minecraft.deepslate_redstone_ore": "Wrevelsteenredstone-erts",
  "block.minecraft.deepslate_tile_slab": "Wrevelstenen tegelplaat",
  "block.minecraft.deepslate_tile_stairs": "Wrevelstenen tegeltrap",
  "block.minecraft.deepslate_tile_wall": "Wrevelstenen tegelmuur",
  "block.minecraft.deepslate_tiles": "Wrevelstenen tegels",
  "block.minecraft.detector_rail": "Detectiespoor",
  "block.minecraft.diamond_block": "Diamantblok",
  "block.minecraft.diamond_ore": "Diamanterts",
  "block.minecraft.diorite": "Dioriet",
  "block.minecraft.diorite_slab": "Diorietplaat",
  "block.minecraft.diorite_stairs": "Dioriettrap",
  "block.minecraft.diorite_wall": "Diorietmuur",
  "block.minecraft.dirt": "Aarde",
  "block.minecraft.dirt_path": "Aardepad",
  "block.minecraft.dispenser": "Dispenser",
  "block.minecraft.dragon_egg": "Drakenei",
  "block.minecraft.dragon_head": "Drakenhoofd",
  "block.minecraft.dragon_wall_head": "Drakenhoofd aan muur",
  "block.minecraft.dried_ghast": "Uitgedroogde Ghast",
  "block.minecraft.dried_kelp_block": "Gedroogd kelpblok",
  "block.minecraft.dripstone_block": "Druipsteenblok",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Smaragdblok",
  "block.minecraft.emerald_ore": "Smaragderts",
  "block.minecraft.enchanting_table": "Betoveringstafel",
  "block.minecraft.end_gateway": "Endtoegangsportaal",
  "block.minecraft.end_portal": "Endportaal",
  "block.minecraft.end_portal_frame": "Endportaalframe",
  "block.minecraft.end_rod": "Endstaf",
  "block.minecraft.end_stone": "Endsteen",
  "block.minecraft.end_stone_brick_slab": "Endblokstenen plaat",
  "block.minecraft.end_stone_brick_stairs": "Endblokstenen trap",
  "block.minecraft.end_stone_brick_wall": "Endblokstenen muur",
  "block.minecraft.end_stone_bricks": "Endblokstenen",
  "block.minecraft.ender_chest": "Enderkist",
  "block.minecraft.exposed_chiseled_copper": "Blootgesteld bewerkt koperblok",
  "block.minecraft.exposed_copper": "Blootgesteld koperblok",
  "block.minecraft.exposed_copper_bars": "Blootgestelde koperen tralies",
  "block.minecraft.exposed_copper_bulb": "Blootgestelde koperen lamp",
  "block.minecraft.exposed_copper_chain": "Blootgestelde koperen ketting",
  "block.minecraft.exposed_copper_chest": "Blootgestelde koperen kist",
  "block.minecraft.exposed_copper_door": "Blootgestelde koperen deur",
  "block.minecraft.exposed_copper_golem_statue": "Blootgesteld kopergolemstandbeeld",
  "block.minecraft.exposed_copper_grate": "Blootgesteld koperen rooster",
  "block.minecraft.exposed_copper_lantern": "Blootgestelde koperen lantaarn",
  "block.minecraft.exposed_copper_trapdoor": "Blootgesteld koperen valluik",
  "block.minecraft.exposed_cut_copper": "Blootgesteld gesneden koperblok",
  "block.minecraft.exposed_cut_copper_slab": "Blootgestelde gesneden koperen plaat",
  "block.minecraft.exposed_cut_copper_stairs": "Blootgestelde gesneden koperen trap",
  "block.minecraft.exposed_lightning_rod": "Blootgestelde bliksemafleider",
  "block.minecraft.farmland": "Akkerland",
  "block.minecraft.fern": "Varen",
  "block.minecraft.fire": "Vuur",
  "block.minecraft.fire_coral": "Brandkoraal",
  "block.minecraft.fire_coral_block": "Brandkoraalblok",
  "block.minecraft.fire_coral_fan": "Brandkoraalwaaier",
  "block.minecraft.fire_coral_wall_fan": "Brandkoraalwaaier aan muur",
  "block.minecraft.firefly_bush": "Vuurvliegjesstruik",
  "block.minecraft.fletching_table": "Bevederingstafel",
  "block.minecraft.flower_pot": "Bloempot",
  "block.minecraft.flowering_azalea": "Bloeiende azalea",
  "block.minecraft.flowering_azalea_leaves": "Bloeiende azaleabladeren",
  "block.minecraft.frogspawn": "Kikkerdril",
  "block.minecraft.frosted_ice": "Gerijpt ijs",
  "block.minecraft.furnace": "Oven",
  "block.minecraft.gilded_blackstone": "Verguld zwartsteen",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glazen ruit",
  "block.minecraft.glow_lichen": "Gloeiend korstmos",
  "block.minecraft.glowstone": "Gloeisteen",
  "block.minecraft.gold_block": "Goudblok",
  "block.minecraft.gold_ore": "Gouderts",
  "block.minecraft.golden_dandelion": "Gouden paardenbloem",
  "block.minecraft.granite": "Graniet",
  "block.minecraft.granite_slab": "Granietplaat",
  "block.minecraft.granite_stairs": "Graniettrap",
  "block.minecraft.granite_wall": "Granietmuur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblok",
  "block.minecraft.gravel": "Grind",
  "block.minecraft.gray_banner": "Grijze banier",
  "block.minecraft.gray_bed": "Grijs bed",
  "block.minecraft.gray_candle": "Grijze kaars",
  "block.minecraft.gray_candle_cake": "Taart met grijze kaars",
  "block.minecraft.gray_carpet": "Grijs tapijt",
  "block.minecraft.gray_concrete": "Grijs beton",
  "block.minecraft.gray_concrete_powder": "Grijs cement",
  "block.minecraft.gray_glazed_terracotta": "Grijsgeglazuurd terracotta",
  "block.minecraft.gray_shulker_box": "Grijze Shulkerdoos",
  "block.minecraft.gray_stained_glass": "Grijsgekleurd glas",
  "block.minecraft.gray_stained_glass_pane": "Grijsgekleurde glazen ruit",
  "block.minecraft.gray_terracotta": "Grijs terracotta",
  "block.minecraft.gray_wool": "Grijze wol",
  "block.minecraft.green_banner": "Groene banier",
  "block.minecraft.green_bed": "Groen bed",
  "block.minecraft.green_candle": "Groene kaars",
  "block.minecraft.green_candle_cake": "Taart met groene kaars",
  "block.minecraft.green_carpet": "Groen tapijt",
  "block.minecraft.green_concrete": "Groen beton",
  "block.minecraft.green_concrete_powder": "Groen cement",
  "block.minecraft.green_glazed_terracotta": "Groengeglazuurd terracotta",
  "block.minecraft.green_shulker_box": "Groene Shulkerdoos",
  "block.minecraft.green_stained_glass": "Groengekleurd glas",
  "block.minecraft.green_stained_glass_pane": "Groengekleurde glazen ruit",
  "block.minecraft.green_terracotta": "Groen terracotta",
  "block.minecraft.green_wool": "Groene wol",
  "block.minecraft.grindstone": "Slijpsteen",
  "block.minecraft.hanging_roots": "Hangende wortels",
  "block.minecraft.hay_block": "Hooibaal",
  "block.minecraft.heavy_core": "Zware kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Zware drukgevoelige plaat",
  "block.minecraft.honey_block": "Honingblok",
  "block.minecraft.honeycomb_block": "Honingraatblok",
  "block.minecraft.hopper": "Trechter",
  "block.minecraft.horn_coral": "Hoornkoraal",
  "block.minecraft.horn_coral_block": "Hoornkoraalblok",
  "block.minecraft.horn_coral_fan": "Hoornkoraalwaaier",
  "block.minecraft.horn_coral_wall_fan": "Hoornkoraalwaaier aan muur",
  "block.minecraft.ice": "IJs",
  "block.minecraft.infested_chiseled_stone_bricks": "Geïnfecteerde gebeitelde blokstenen",
  "block.minecraft.infested_cobblestone": "Geïnfecteerde keisteen",
  "block.minecraft.infested_cracked_stone_bricks": "Geïnfecteerde gebarsten blokstenen",
  "block.minecraft.infested_deepslate": "Geïnfecteerd wrevelsteen",
  "block.minecraft.infested_mossy_stone_bricks": "Geïnfecteerde mossige blokstenen",
  "block.minecraft.infested_stone": "Geïnfecteerde steen",
  "block.minecraft.infested_stone_bricks": "Geïnfecteerde blokstenen",
  "block.minecraft.iron_bars": "IJzeren tralies",
  "block.minecraft.iron_block": "IJzerblok",
  "block.minecraft.iron_chain": "IJzeren ketting",
  "block.minecraft.iron_door": "IJzeren deur",
  "block.minecraft.iron_ore": "IJzererts",
  "block.minecraft.iron_trapdoor": "IJzeren valluik",
  "block.minecraft.jack_o_lantern": "Jack-o'-lantern",
  "block.minecraft.jigsaw": "Puzzelblok",
  "block.minecraft.jukebox": "Platenspeler",
  "block.minecraft.jungle_button": "Oerwoudhouten knop",
  "block.minecraft.jungle_door": "Oerwoudhouten deur",
  "block.minecraft.jungle_fence": "Oerwoudhouten hek",
  "block.minecraft.jungle_fence_gate": "Oerwoudhouten poort",
  "block.minecraft.jungle_hanging_sign": "Oerwoudhouten hangbord",
  "block.minecraft.jungle_leaves": "Oerwoudbladeren",
  "block.minecraft.jungle_log": "Oerwoudstam",
  "block.minecraft.jungle_planks": "Oerwoudhouten planken",
  "block.minecraft.jungle_pressure_plate": "Oerwoudhouten drukplaat",
  "block.minecraft.jungle_sapling": "Oerwoudzaailing",
  "block.minecraft.jungle_shelf": "Oerwoudhouten schap",
  "block.minecraft.jungle_sign": "Oerwoudhouten bord",
  "block.minecraft.jungle_slab": "Oerwoudhouten plaat",
  "block.minecraft.jungle_stairs": "Oerwoudhouten trap",
  "block.minecraft.jungle_trapdoor": "Oerwoudhouten valluik",
  "block.minecraft.jungle_wall_hanging_sign": "Oerwoudhouten uithangbord",
  "block.minecraft.jungle_wall_sign": "Oerwoudhouten bord aan muur",
  "block.minecraft.jungle_wood": "Oerwoudhout",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpplant",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Lantaarn",
  "block.minecraft.lapis_block": "Lapislazuliblok",
  "block.minecraft.lapis_ore": "Lapis lazuli-erts",
  "block.minecraft.large_amethyst_bud": "Grote amethistknop",
  "block.minecraft.large_fern": "Grote varen",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Ketel met lava",
  "block.minecraft.leaf_litter": "Dode bladeren",
  "block.minecraft.lectern": "Lessenaar",
  "block.minecraft.lever": "Hendel",
  "block.minecraft.light": "Licht",
  "block.minecraft.light_blue_banner": "Lichtblauwe banier",
  "block.minecraft.light_blue_bed": "Lichtblauw bed",
  "block.minecraft.light_blue_candle": "Lichtblauwe kaars",
  "block.minecraft.light_blue_candle_cake": "Taart met lichtblauwe kaars",
  "block.minecraft.light_blue_carpet": "Lichtblauw tapijt",
  "block.minecraft.light_blue_concrete": "Lichtblauw beton",
  "block.minecraft.light_blue_concrete_powder": "Lichtblauw cement",
  "block.minecraft.light_blue_glazed_terracotta": "Lichtblauwgeglazuurd terracotta",
  "block.minecraft.light_blue_shulker_box": "Lichtblauwe Shulkerdoos",
  "block.minecraft.light_blue_stained_glass": "Lichtblauwgekleurd glas",
  "block.minecraft.light_blue_stained_glass_pane": "Lichtblauwgekleurde glazen ruit",
  "block.minecraft.light_blue_terracotta": "Lichtblauw terracotta",
  "block.minecraft.light_blue_wool": "Lichtblauwe wol",
  "block.minecraft.light_gray_banner": "Lichtgrijze banier",
  "block.minecraft.light_gray_bed": "Lichtgrijs bed",
  "block.minecraft.light_gray_candle": "Lichtgrijze kaars",
  "block.minecraft.light_gray_candle_cake": "Taart met lichtgrijze kaars",
  "block.minecraft.light_gray_carpet": "Lichtgrijs tapijt",
  "block.minecraft.light_gray_concrete": "Lichtgrijs beton",
  "block.minecraft.light_gray_concrete_powder": "Lichtgrijs cement",
  "block.minecraft.light_gray_glazed_terracotta": "Lichtgrijsgeglazuurd terracotta",
  "block.minecraft.light_gray_shulker_box": "Lichtgrijze Shulkerdoos",
  "block.minecraft.light_gray_stained_glass": "Lichtgrijsgekleurd glas",
  "block.minecraft.light_gray_stained_glass_pane": "Lichtgrijsgekleurde glazen ruit",
  "block.minecraft.light_gray_terracotta": "Lichtgrijs terracotta",
  "block.minecraft.light_gray_wool": "Lichtgrijze wol",
  "block.minecraft.light_weighted_pressure_plate": "Lichte drukgevoelige plaat",
  "block.minecraft.lightning_rod": "Bliksemafleider",
  "block.minecraft.lilac": "Sering",
  "block.minecraft.lily_of_the_valley": "Lelietje-van-dalen",
  "block.minecraft.lily_pad": "Waterlelie",
  "block.minecraft.lime_banner": "Lichtgroene banier",
  "block.minecraft.lime_bed": "Lichtgroen bed",
  "block.minecraft.lime_candle": "Lichtgroene kaars",
  "block.minecraft.lime_candle_cake": "Taart met lichtgroene kaars",
  "block.minecraft.lime_carpet": "Lichtgroen tapijt",
  "block.minecraft.lime_concrete": "Lichtgroen beton",
  "block.minecraft.lime_concrete_powder": "Lichtgroen cement",
  "block.minecraft.lime_glazed_terracotta": "Lichtgroengeglazuurd terracotta",
  "block.minecraft.lime_shulker_box": "Lichtgroene Shulkerdoos",
  "block.minecraft.lime_stained_glass": "Lichtgroengekleurd glas",
  "block.minecraft.lime_stained_glass_pane": "Lichtgroengekleurde glazen ruit",
  "block.minecraft.lime_terracotta": "Lichtgroen terracotta",
  "block.minecraft.lime_wool": "Lichtgroene wol",
  "block.minecraft.lodestone": "Zeilsteen",
  "block.minecraft.loom": "Weefgetouw",
  "block.minecraft.magenta_banner": "Magenta banier",
  "block.minecraft.magenta_bed": "Magenta bed",
  "block.minecraft.magenta_candle": "Magenta kaars",
  "block.minecraft.magenta_candle_cake": "Taart met magenta kaars",
  "block.minecraft.magenta_carpet": "Magenta tapijt",
  "block.minecraft.magenta_concrete": "Magenta beton",
  "block.minecraft.magenta_concrete_powder": "Magenta cement",
  "block.minecraft.magenta_glazed_terracotta": "Magentageglazuurd terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulkerdoos",
  "block.minecraft.magenta_stained_glass": "Magentagekleurd glas",
  "block.minecraft.magenta_stained_glass_pane": "Magentagekleurde glazen ruit",
  "block.minecraft.magenta_terracotta": "Magenta terracotta",
  "block.minecraft.magenta_wool": "Magenta wol",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrovehouten knop",
  "block.minecraft.mangrove_door": "Mangrovehouten deur",
  "block.minecraft.mangrove_fence": "Mangrovehouten hek",
  "block.minecraft.mangrove_fence_gate": "Mangrovehouten poort",
  "block.minecraft.mangrove_hanging_sign": "Mangrovehouten hangbord",
  "block.minecraft.mangrove_leaves": "Mangrovebladeren",
  "block.minecraft.mangrove_log": "Mangrovestam",
  "block.minecraft.mangrove_planks": "Mangrovehouten planken",
  "block.minecraft.mangrove_pressure_plate": "Mangrovehouten drukplaat",
  "block.minecraft.mangrove_propagule": "Mangrovebroedknop",
  "block.minecraft.mangrove_roots": "Mangrovewortels",
  "block.minecraft.mangrove_shelf": "Mangrovehouten schap",
  "block.minecraft.mangrove_sign": "Mangrovehouten bord",
  "block.minecraft.mangrove_slab": "Mangrovehouten plaat",
  "block.minecraft.mangrove_stairs": "Mangrovehouten trap",
  "block.minecraft.mangrove_trapdoor": "Mangrovehouten valluik",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovehouten uithangbord",
  "block.minecraft.mangrove_wall_sign": "Mangrovehouten bord aan muur",
  "block.minecraft.mangrove_wood": "Mangrovehout",
  "block.minecraft.medium_amethyst_bud": "Middelgrote amethistknop",
  "block.minecraft.melon": "Meloen",
  "block.minecraft.melon_stem": "Meloenstam",
  "block.minecraft.moss_block": "Mosblok",
  "block.minecraft.moss_carpet": "Mostapijt",
  "block.minecraft.mossy_cobblestone": "Mossige keisteen",
  "block.minecraft.mossy_cobblestone_slab": "Mossige keistenen plaat",
  "block.minecraft.mossy_cobblestone_stairs": "Mossige keistenen trap",
  "block.minecraft.mossy_cobblestone_wall": "Mossige keistenen muur",
  "block.minecraft.mossy_stone_brick_slab": "Mossige blokstenen plaat",
  "block.minecraft.mossy_stone_brick_stairs": "Mossige blokstenen trap",
  "block.minecraft.mossy_stone_brick_wall": "Mossige blokstenen muur",
  "block.minecraft.mossy_stone_bricks": "Mossige blokstenen",
  "block.minecraft.moving_piston": "Bewegende zuiger",
  "block.minecraft.mud": "Modder",
  "block.minecraft.mud_brick_slab": "Modderstenen plaat",
  "block.minecraft.mud_brick_stairs": "Modderstenen trap",
  "block.minecraft.mud_brick_wall": "Modderstenen muur",
  "block.minecraft.mud_bricks": "Modderstenen",
  "block.minecraft.muddy_mangrove_roots": "Modderige mangrovewortels",
  "block.minecraft.mushroom_stem": "Paddenstoelenstam",
  "block.minecraft.mycelium": "Zwamvlok",
  "block.minecraft.nether_brick_fence": "Netherbakstenen hek",
  "block.minecraft.nether_brick_slab": "Netherbakstenen plaat",
  "block.minecraft.nether_brick_stairs": "Netherbakstenen trap",
  "block.minecraft.nether_brick_wall": "Netherbakstenen muur",
  "block.minecraft.nether_bricks": "Netherbakstenen",
  "block.minecraft.nether_gold_ore": "Nethergouderts",
  "block.minecraft.nether_portal": "Netherportaal",
  "block.minecraft.nether_quartz_ore": "Netherkwartserts",
  "block.minecraft.nether_sprouts": "Netherscheuten",
  "block.minecraft.nether_wart": "Netherkruid",
  "block.minecraft.nether_wart_block": "Netherkruidblok",
  "block.minecraft.netherite_block": "Netherietblok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nootblok",
  "block.minecraft.oak_button": "Eikenhouten knop",
  "block.minecraft.oak_door": "Eikenhouten deur",
  "block.minecraft.oak_fence": "Eikenhouten hek",
  "block.minecraft.oak_fence_gate": "Eikenhouten poort",
  "block.minecraft.oak_hanging_sign": "Eikenhouten hangbord",
  "block.minecraft.oak_leaves": "Eikenbladeren",
  "block.minecraft.oak_log": "Eikenstam",
  "block.minecraft.oak_planks": "Eikenhouten planken",
  "block.minecraft.oak_pressure_plate": "Eikenhouten drukplaat",
  "block.minecraft.oak_sapling": "Eikenzaailing",
  "block.minecraft.oak_shelf": "Eikenhouten schap",
  "block.minecraft.oak_sign": "Eikenhouten bord",
  "block.minecraft.oak_slab": "Eikenhouten plaat",
  "block.minecraft.oak_stairs": "Eikenhouten trap",
  "block.minecraft.oak_trapdoor": "Eikenhouten valluik",
  "block.minecraft.oak_wall_hanging_sign": "Eikenhouten uithangbord",
  "block.minecraft.oak_wall_sign": "Eikenhouten bord aan muur",
  "block.minecraft.oak_wood": "Eikenhout",
  "block.minecraft.observer": "Observeerder",
  "block.minecraft.obsidian": "Obsidiaan",
  "block.minecraft.ochre_froglight": "Okergeel kikkerlicht",
  "block.minecraft.ominous_banner": "Onheilspellende banier",
  "block.minecraft.open_eyeblossom": "Geopende gluurbloesem",
  "block.minecraft.orange_banner": "Oranje banier",
  "block.minecraft.orange_bed": "Oranje bed",
  "block.minecraft.orange_candle": "Oranje kaars",
  "block.minecraft.orange_candle_cake": "Taart met oranje kaars",
  "block.minecraft.orange_carpet": "Oranje tapijt",
  "block.minecraft.orange_concrete": "Oranje beton",
  "block.minecraft.orange_concrete_powder": "Oranje cement",
  "block.minecraft.orange_glazed_terracotta": "Oranjegeglazuurd terracotta",
  "block.minecraft.orange_shulker_box": "Oranje Shulkerdoos",
  "block.minecraft.orange_stained_glass": "Oranjegekleurd glas",
  "block.minecraft.orange_stained_glass_pane": "Oranjegekleurde glazen ruit",
  "block.minecraft.orange_terracotta": "Oranje terracotta",
  "block.minecraft.orange_tulip": "Oranje tulp",
  "block.minecraft.orange_wool": "Oranje wol",
  "block.minecraft.oxeye_daisy": "Margriet",
  "block.minecraft.oxidized_chiseled_copper": "Geoxideerd bewerkt koperblok",
  "block.minecraft.oxidized_copper": "Geoxideerd koperblok",
  "block.minecraft.oxidized_copper_bars": "Geoxideerde koperen tralies",
  "block.minecraft.oxidized_copper_bulb": "Geoxideerde koperen lamp",
  "block.minecraft.oxidized_copper_chain": "Geoxideerde koperen ketting",
  "block.minecraft.oxidized_copper_chest": "Geoxideerde koperen kist",
  "block.minecraft.oxidized_copper_door": "Geoxideerde koperen deur",
  "block.minecraft.oxidized_copper_golem_statue": "Geoxideerd kopergolemstandbeeld",
  "block.minecraft.oxidized_copper_grate": "Geoxideerd koperen rooster",
  "block.minecraft.oxidized_copper_lantern": "Geoxideerde koperen lantaarn",
  "block.minecraft.oxidized_copper_trapdoor": "Geoxideerd koperen valluik",
  "block.minecraft.oxidized_cut_copper": "Geoxideerd gesneden koperblok",
  "block.minecraft.oxidized_cut_copper_slab": "Geoxideerde gesneden koperen plaat",
  "block.minecraft.oxidized_cut_copper_stairs": "Geoxideerde gesneden koperen trap",
  "block.minecraft.oxidized_lightning_rod": "Geoxideerde bliksemafleider",
  "block.minecraft.packed_ice": "Pakijs",
  "block.minecraft.packed_mud": "Pakmodder",
  "block.minecraft.pale_hanging_moss": "Bleek hangend mos",
  "block.minecraft.pale_moss_block": "Bleek mosblok",
  "block.minecraft.pale_moss_carpet": "Bleek mostapijt",
  "block.minecraft.pale_oak_button": "Bleke eikenhouten knop",
  "block.minecraft.pale_oak_door": "Bleke eikenhouten deur",
  "block.minecraft.pale_oak_fence": "Bleek eikenhouten hek",
  "block.minecraft.pale_oak_fence_gate": "Bleke eikenhouten poort",
  "block.minecraft.pale_oak_hanging_sign": "Bleek eikenhouten hangbord",
  "block.minecraft.pale_oak_leaves": "Bleke eikenbladeren",
  "block.minecraft.pale_oak_log": "Bleke eikenstam",
  "block.minecraft.pale_oak_planks": "Bleke eikenhouten planken",
  "block.minecraft.pale_oak_pressure_plate": "Bleke eikenhouten drukplaat",
  "block.minecraft.pale_oak_sapling": "Bleke eikenzaailing",
  "block.minecraft.pale_oak_shelf": "Bleek eikenhouten schap",
  "block.minecraft.pale_oak_sign": "Bleek eikenhouten bord",
  "block.minecraft.pale_oak_slab": "Bleke eikenhouten plaat",
  "block.minecraft.pale_oak_stairs": "Bleke eikenhouten trap",
  "block.minecraft.pale_oak_trapdoor": "Bleke eikenhouten valluik",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bleek eikenhouten uithangbord",
  "block.minecraft.pale_oak_wall_sign": "Bleek eikenhouten bord aan muur",
  "block.minecraft.pale_oak_wood": "Bleek eikenhout",
  "block.minecraft.pearlescent_froglight": "Paars kikkerlicht",
  "block.minecraft.peony": "Pioenroos",
  "block.minecraft.petrified_oak_slab": "Versteende eikenhouten plaat",
  "block.minecraft.piglin_head": "Piglinhoofd",
  "block.minecraft.piglin_wall_head": "Piglinhoofd aan muur",
  "block.minecraft.pink_banner": "Roze banier",
  "block.minecraft.pink_bed": "Roze bed",
  "block.minecraft.pink_candle": "Roze kaars",
  "block.minecraft.pink_candle_cake": "Taart met roze kaars",
  "block.minecraft.pink_carpet": "Roze tapijt",
  "block.minecraft.pink_concrete": "Roze beton",
  "block.minecraft.pink_concrete_powder": "Roze cement",
  "block.minecraft.pink_glazed_terracotta": "Rozegeglazuurd terracotta",
  "block.minecraft.pink_petals": "Roze bloemblaadjes",
  "block.minecraft.pink_shulker_box": "Roze Shulkerdoos",
  "block.minecraft.pink_stained_glass": "Rozegekleurd glas",
  "block.minecraft.pink_stained_glass_pane": "Rozegekleurde glazen ruit",
  "block.minecraft.pink_terracotta": "Roze terracotta",
  "block.minecraft.pink_tulip": "Roze tulp",
  "block.minecraft.pink_wool": "Roze wol",
  "block.minecraft.piston": "Zuiger",
  "block.minecraft.piston_head": "Zuigerhoofd",
  "block.minecraft.pitcher_crop": "Bekerplantgewas",
  "block.minecraft.pitcher_plant": "Bekerplant",
  "block.minecraft.player_head": "Spelershoofd",
  "block.minecraft.player_head.named": "Hoofd van %s",
  "block.minecraft.player_wall_head": "Spelerhoofd aan muur",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Puntige druipsteen",
  "block.minecraft.polished_andesite": "Gepolijst andesiet",
  "block.minecraft.polished_andesite_slab": "Gepolijste andesietplaat",
  "block.minecraft.polished_andesite_stairs": "Gepolijste andesiettrap",
  "block.minecraft.polished_basalt": "Gepolijst basalt",
  "block.minecraft.polished_blackstone": "Gepolijst zwartsteen",
  "block.minecraft.polished_blackstone_brick_slab": "Gepolijste zwartstenen blokstenen plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "Gepolijste zwartstenen blokstenen trap",
  "block.minecraft.polished_blackstone_brick_wall": "Gepolijste zwartstenen blokstenen muur",
  "block.minecraft.polished_blackstone_bricks": "Gepolijste zwartstenen blokstenen",
  "block.minecraft.polished_blackstone_button": "Gepolijste zwartstenen knop",
  "block.minecraft.polished_blackstone_pressure_plate": "Gepolijste zwartstenen drukplaat",
  "block.minecraft.polished_blackstone_slab": "Gepolijste zwartstenen plaat",
  "block.minecraft.polished_blackstone_stairs": "Gepolijste zwartstenen trap",
  "block.minecraft.polished_blackstone_wall": "Gepolijste zwartstenen muur",
  "block.minecraft.polished_deepslate": "Gepolijst wrevelsteen",
  "block.minecraft.polished_deepslate_slab": "Gepolijste wrevelstenen plaat",
  "block.minecraft.polished_deepslate_stairs": "Gepolijste wrevelstenen trap",
  "block.minecraft.polished_deepslate_wall": "Gepolijste wrevelstenen muur",
  "block.minecraft.polished_diorite": "Gepolijst dioriet",
  "block.minecraft.polished_diorite_slab": "Gepolijste diorietplaat",
  "block.minecraft.polished_diorite_stairs": "Gepolijste dioriettrap",
  "block.minecraft.polished_granite": "Gepolijst graniet",
  "block.minecraft.polished_granite_slab": "Gepolijste granietplaat",
  "block.minecraft.polished_granite_stairs": "Gepolijste graniettrap",
  "block.minecraft.polished_tuff": "Gepolijst tufsteen",
  "block.minecraft.polished_tuff_slab": "Gepolijste tufstenen plaat",
  "block.minecraft.polished_tuff_stairs": "Gepolijste tufstenen trap",
  "block.minecraft.polished_tuff_wall": "Gepolijste tufstenen muur",
  "block.minecraft.poppy": "Klaproos",
  "block.minecraft.potatoes": "Aardappels",
  "block.minecraft.potted_acacia_sapling": "Opgepotte acaciazaailing",
  "block.minecraft.potted_allium": "Opgepot look",
  "block.minecraft.potted_azalea_bush": "Opgepotte azalea",
  "block.minecraft.potted_azure_bluet": "Opgepot porseleinsterretje",
  "block.minecraft.potted_bamboo": "Opgepotte bamboe",
  "block.minecraft.potted_birch_sapling": "Opgepotte berkenzaailing",
  "block.minecraft.potted_blue_orchid": "Opgepotte blauwe orchidee",
  "block.minecraft.potted_brown_mushroom": "Opgepotte bruine paddenstoel",
  "block.minecraft.potted_cactus": "Opgepotte cactus",
  "block.minecraft.potted_cherry_sapling": "Opgepotte kersenzaailing",
  "block.minecraft.potted_closed_eyeblossom": "Opgepotte gesloten gluurbloesem",
  "block.minecraft.potted_cornflower": "Opgepotte korenbloem",
  "block.minecraft.potted_crimson_fungus": "Opgepotte helrode zwam",
  "block.minecraft.potted_crimson_roots": "Opgepotte helrode wortels",
  "block.minecraft.potted_dandelion": "Opgepotte paardenbloem",
  "block.minecraft.potted_dark_oak_sapling": "Opgepotte donkere eikenzaailing",
  "block.minecraft.potted_dead_bush": "Opgepotte dode struik",
  "block.minecraft.potted_fern": "Opgepotte varen",
  "block.minecraft.potted_flowering_azalea_bush": "Opgepotte bloeiende azalea",
  "block.minecraft.potted_golden_dandelion": "Opgepotte gouden paardenbloem",
  "block.minecraft.potted_jungle_sapling": "Opgepotte oerwoudzaailing",
  "block.minecraft.potted_lily_of_the_valley": "Opgepot lelietje-van-dalen",
  "block.minecraft.potted_mangrove_propagule": "Opgepotte mangrovebroedknop",
  "block.minecraft.potted_oak_sapling": "Opgepotte eikenzaailing",
  "block.minecraft.potted_open_eyeblossom": "Opgepotte geopende gluurbloesem",
  "block.minecraft.potted_orange_tulip": "Opgepotte oranje tulp",
  "block.minecraft.potted_oxeye_daisy": "Opgepotte margriet",
  "block.minecraft.potted_pale_oak_sapling": "Opgepotte bleke eikenzaailing",
  "block.minecraft.potted_pink_tulip": "Opgepotte roze tulp",
  "block.minecraft.potted_poppy": "Opgepotte klaproos",
  "block.minecraft.potted_red_mushroom": "Opgepotte rode paddenstoel",
  "block.minecraft.potted_red_tulip": "Opgepotte rode tulp",
  "block.minecraft.potted_spruce_sapling": "Opgepotte sparrenzaailing",
  "block.minecraft.potted_torchflower": "Opgepotte fakkelbloem",
  "block.minecraft.potted_warped_fungus": "Opgepotte spookachtige zwam",
  "block.minecraft.potted_warped_roots": "Opgepotte spookachtige wortels",
  "block.minecraft.potted_white_tulip": "Opgepotte witte tulp",
  "block.minecraft.potted_wither_rose": "Opgepotte Witherroos",
  "block.minecraft.powder_snow": "Poedersneeuw",
  "block.minecraft.powder_snow_cauldron": "Ketel met poedersneeuw",
  "block.minecraft.powered_rail": "Aandrijfspoor",
  "block.minecraft.prismarine": "Prismarien",
  "block.minecraft.prismarine_brick_slab": "Prismarienblokstenen plaat",
  "block.minecraft.prismarine_brick_stairs": "Prismarienblokstenen trap",
  "block.minecraft.prismarine_bricks": "Prismarienblokstenen",
  "block.minecraft.prismarine_slab": "Prismarienplaat",
  "block.minecraft.prismarine_stairs": "Prismarientrap",
  "block.minecraft.prismarine_wall": "Prismarienmuur",
  "block.minecraft.pumpkin": "Pompoen",
  "block.minecraft.pumpkin_stem": "Pompoenstam",
  "block.minecraft.purple_banner": "Paarse banier",
  "block.minecraft.purple_bed": "Paars bed",
  "block.minecraft.purple_candle": "Paarse kaars",
  "block.minecraft.purple_candle_cake": "Taart met paarse kaars",
  "block.minecraft.purple_carpet": "Paars tapijt",
  "block.minecraft.purple_concrete": "Paars beton",
  "block.minecraft.purple_concrete_powder": "Paars cement",
  "block.minecraft.purple_glazed_terracotta": "Paarsgeglazuurd terracotta",
  "block.minecraft.purple_shulker_box": "Paarse Shulkerdoos",
  "block.minecraft.purple_stained_glass": "Paarsgekleurd glas",
  "block.minecraft.purple_stained_glass_pane": "Paarsgekleurde glazen ruit",
  "block.minecraft.purple_terracotta": "Paars terracotta",
  "block.minecraft.purple_wool": "Paarse wol",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpurpilaar",
  "block.minecraft.purpur_slab": "Purpurplaat",
  "block.minecraft.purpur_stairs": "Purpurtrap",
  "block.minecraft.quartz_block": "Kwartsblok",
  "block.minecraft.quartz_bricks": "Kwartsblokstenen",
  "block.minecraft.quartz_pillar": "Kwartspilaar",
  "block.minecraft.quartz_slab": "Kwartsplaat",
  "block.minecraft.quartz_stairs": "Kwartstrap",
  "block.minecraft.rail": "Spoor",
  "block.minecraft.raw_copper_block": "Ruw koperblok",
  "block.minecraft.raw_gold_block": "Ruw goudblok",
  "block.minecraft.raw_iron_block": "Ruw ijzerblok",
  "block.minecraft.red_banner": "Rode banier",
  "block.minecraft.red_bed": "Rood bed",
  "block.minecraft.red_candle": "Rode kaars",
  "block.minecraft.red_candle_cake": "Taart met rode kaars",
  "block.minecraft.red_carpet": "Rood tapijt",
  "block.minecraft.red_concrete": "Rood beton",
  "block.minecraft.red_concrete_powder": "Rood cement",
  "block.minecraft.red_glazed_terracotta": "Roodgeglazuurd terracotta",
  "block.minecraft.red_mushroom": "Rode paddenstoel",
  "block.minecraft.red_mushroom_block": "Rood paddenstoelenblok",
  "block.minecraft.red_nether_brick_slab": "Rode Netherbakstenen plaat",
  "block.minecraft.red_nether_brick_stairs": "Rode Netherbakstenen trap",
  "block.minecraft.red_nether_brick_wall": "Rode Netherbakstenen muur",
  "block.minecraft.red_nether_bricks": "Rode Netherbakstenen",
  "block.minecraft.red_sand": "Rood zand",
  "block.minecraft.red_sandstone": "Rood zandsteen",
  "block.minecraft.red_sandstone_slab": "Rode zandstenen plaat",
  "block.minecraft.red_sandstone_stairs": "Rode zandstenen trap",
  "block.minecraft.red_sandstone_wall": "Rode zandstenen muur",
  "block.minecraft.red_shulker_box": "Rode Shulkerdoos",
  "block.minecraft.red_stained_glass": "Roodgekleurd glas",
  "block.minecraft.red_stained_glass_pane": "Roodgekleurde glazen ruit",
  "block.minecraft.red_terracotta": "Rood terracotta",
  "block.minecraft.red_tulip": "Rode tulp",
  "block.minecraft.red_wool": "Rode wol",
  "block.minecraft.redstone_block": "Redstoneblok",
  "block.minecraft.redstone_lamp": "Redstonelamp",
  "block.minecraft.redstone_ore": "Redstone-erts",
  "block.minecraft.redstone_torch": "Redstonefakkel",
  "block.minecraft.redstone_wall_torch": "Redstonefakkel aan muur",
  "block.minecraft.redstone_wire": "Redstonedraad",
  "block.minecraft.reinforced_deepslate": "Gewapend wrevelsteen",
  "block.minecraft.repeater": "Redstoneversterker",
  "block.minecraft.repeating_command_block": "Herhalend opdrachtblok",
  "block.minecraft.resin_block": "Harsblok",
  "block.minecraft.resin_brick_slab": "Harsbakstenen plaat",
  "block.minecraft.resin_brick_stairs": "Harsbakstenen trap",
  "block.minecraft.resin_brick_wall": "Harsbakstenen muur",
  "block.minecraft.resin_bricks": "Harsbakstenen",
  "block.minecraft.resin_clump": "Harsdruppels",
  "block.minecraft.respawn_anchor": "Respawnanker",
  "block.minecraft.rooted_dirt": "Gewortelde aarde",
  "block.minecraft.rose_bush": "Rozenstruik",
  "block.minecraft.sand": "Zand",
  "block.minecraft.sandstone": "Zandsteen",
  "block.minecraft.sandstone_slab": "Zandstenen plaat",
  "block.minecraft.sandstone_stairs": "Zandstenen trap",
  "block.minecraft.sandstone_wall": "Zandstenen muur",
  "block.minecraft.scaffolding": "Steiger",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkkrijser",
  "block.minecraft.sculk_vein": "Sculkader",
  "block.minecraft.sea_lantern": "Zeelantaarn",
  "block.minecraft.sea_pickle": "Zeeaugurk",
  "block.minecraft.seagrass": "Zeegras",
  "block.minecraft.set_spawn": "Respawnpunt ingesteld",
  "block.minecraft.short_dry_grass": "Kort droog gras",
  "block.minecraft.short_grass": "Kort gras",
  "block.minecraft.shroomlight": "Zwammenlicht",
  "block.minecraft.shulker_box": "Shulkerdoos",
  "block.minecraft.skeleton_skull": "Skelettenschedel",
  "block.minecraft.skeleton_wall_skull": "Skelettenschedel aan muur",
  "block.minecraft.slime_block": "Slijmblok",
  "block.minecraft.small_amethyst_bud": "Kleine amethistknop",
  "block.minecraft.small_dripleaf": "Klein druipblad",
  "block.minecraft.smithing_table": "Smeedstafel",
  "block.minecraft.smoker": "Roker",
  "block.minecraft.smooth_basalt": "Glad basalt",
  "block.minecraft.smooth_quartz": "Glad kwartsblok",
  "block.minecraft.smooth_quartz_slab": "Gladde kwartsplaat",
  "block.minecraft.smooth_quartz_stairs": "Gladde kwartstrap",
  "block.minecraft.smooth_red_sandstone": "Glad rood zandsteen",
  "block.minecraft.smooth_red_sandstone_slab": "Gladde rode zandstenen plaat",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladde rode zandstenen trap",
  "block.minecraft.smooth_sandstone": "Glad zandsteen",
  "block.minecraft.smooth_sandstone_slab": "Gladde zandstenen plaat",
  "block.minecraft.smooth_sandstone_stairs": "Gladde zandstenen trap",
  "block.minecraft.smooth_stone": "Gladde steen",
  "block.minecraft.smooth_stone_slab": "Gladde stenen plaat",
  "block.minecraft.sniffer_egg": "Snuffelaarsei",
  "block.minecraft.snow": "Sneeuw",
  "block.minecraft.snow_block": "Sneeuwblok",
  "block.minecraft.soul_campfire": "Zielenkampvuur",
  "block.minecraft.soul_fire": "Zielenvuur",
  "block.minecraft.soul_lantern": "Zielenlantaarn",
  "block.minecraft.soul_sand": "Zielenzand",
  "block.minecraft.soul_soil": "Zielenaarde",
  "block.minecraft.soul_torch": "Zielenfakkel",
  "block.minecraft.soul_wall_torch": "Zielenfakkel aan muur",
  "block.minecraft.spawn.not_valid": "Je hebt geen bed of opgeladen respawnanker of ze waren geblokkeerd",
  "block.minecraft.spawner": "Monsterkooi",
  "block.minecraft.spawner.desc1": "Interactie met spawnei:",
  "block.minecraft.spawner.desc2": "Bepaalt te spawnen wezentype",
  "block.minecraft.sponge": "Spons",
  "block.minecraft.spore_blossom": "Sporebloesem",
  "block.minecraft.spruce_button": "Sparrenhouten knop",
  "block.minecraft.spruce_door": "Sparrenhouten deur",
  "block.minecraft.spruce_fence": "Sparrenhouten hek",
  "block.minecraft.spruce_fence_gate": "Sparrenhouten poort",
  "block.minecraft.spruce_hanging_sign": "Sparrenhouten hangbord",
  "block.minecraft.spruce_leaves": "Sparrennaalden",
  "block.minecraft.spruce_log": "Sparrenstam",
  "block.minecraft.spruce_planks": "Sparrenhouten planken",
  "block.minecraft.spruce_pressure_plate": "Sparrenhouten drukplaat",
  "block.minecraft.spruce_sapling": "Sparrenzaailing",
  "block.minecraft.spruce_shelf": "Sparrenhouten schap",
  "block.minecraft.spruce_sign": "Sparrenhouten bord",
  "block.minecraft.spruce_slab": "Sparrenhouten plaat",
  "block.minecraft.spruce_stairs": "Sparrenhouten trap",
  "block.minecraft.spruce_trapdoor": "Sparrenhouten valluik",
  "block.minecraft.spruce_wall_hanging_sign": "Sparrenhouten uithangbord",
  "block.minecraft.spruce_wall_sign": "Sparrenhouten bord aan muur",
  "block.minecraft.spruce_wood": "Sparrenhout",
  "block.minecraft.sticky_piston": "Kleefzuiger",
  "block.minecraft.stone": "Steen",
  "block.minecraft.stone_brick_slab": "Blokstenen plaat",
  "block.minecraft.stone_brick_stairs": "Blokstenen trap",
  "block.minecraft.stone_brick_wall": "Blokstenen muur",
  "block.minecraft.stone_bricks": "Blokstenen",
  "block.minecraft.stone_button": "Stenen knop",
  "block.minecraft.stone_pressure_plate": "Stenen drukplaat",
  "block.minecraft.stone_slab": "Stenen plaat",
  "block.minecraft.stone_stairs": "Stenen trap",
  "block.minecraft.stonecutter": "Steenzaag",
  "block.minecraft.stripped_acacia_log": "Gestripte acaciastam",
  "block.minecraft.stripped_acacia_wood": "Gestript acaciahout",
  "block.minecraft.stripped_bamboo_block": "Gestript bamboeblok",
  "block.minecraft.stripped_birch_log": "Gestripte berkenstam",
  "block.minecraft.stripped_birch_wood": "Gestript berkenhout",
  "block.minecraft.stripped_cherry_log": "Gestripte kersenboomstam",
  "block.minecraft.stripped_cherry_wood": "Gestript kersenhout",
  "block.minecraft.stripped_crimson_hyphae": "Gestripte helrode schimmeldraden",
  "block.minecraft.stripped_crimson_stem": "Gestripte helrode stam",
  "block.minecraft.stripped_dark_oak_log": "Gestripte donkere eikenstam",
  "block.minecraft.stripped_dark_oak_wood": "Gestript donker eikenhout",
  "block.minecraft.stripped_jungle_log": "Gestripte oerwoudstam",
  "block.minecraft.stripped_jungle_wood": "Gestript oerwoudhout",
  "block.minecraft.stripped_mangrove_log": "Gestripte mangrovestam",
  "block.minecraft.stripped_mangrove_wood": "Gestript mangrovehout",
  "block.minecraft.stripped_oak_log": "Gestripte eikenstam",
  "block.minecraft.stripped_oak_wood": "Gestript eikenhout",
  "block.minecraft.stripped_pale_oak_log": "Gestripte bleke eikenstam",
  "block.minecraft.stripped_pale_oak_wood": "Gestript bleek eikenhout",
  "block.minecraft.stripped_spruce_log": "Gestripte sparrenstam",
  "block.minecraft.stripped_spruce_wood": "Gestript sparrenhout",
  "block.minecraft.stripped_warped_hyphae": "Gestripte spookachtige schimmeldraden",
  "block.minecraft.stripped_warped_stem": "Gestripte spookachtige stam",
  "block.minecraft.structure_block": "Constructieblok",
  "block.minecraft.structure_void": "Constructieleegte",
  "block.minecraft.sugar_cane": "Suikerriet",
  "block.minecraft.sunflower": "Zonnebloem",
  "block.minecraft.suspicious_gravel": "Verdacht grind",
  "block.minecraft.suspicious_sand": "Verdacht zand",
  "block.minecraft.sweet_berry_bush": "Zoetbesstruik",
  "block.minecraft.tall_dry_grass": "Hoog droog gras",
  "block.minecraft.tall_grass": "Hoog gras",
  "block.minecraft.tall_seagrass": "Hoog zeegras",
  "block.minecraft.target": "Doelwit",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Testblok",
  "block.minecraft.test_instance_block": "Testinstantieblok",
  "block.minecraft.tinted_glass": "Getint glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-explosies zijn uitgeschakeld",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelbloem",
  "block.minecraft.torchflower_crop": "Fakkelbloemgewas",
  "block.minecraft.trapped_chest": "Kist met valstrik",
  "block.minecraft.trial_spawner": "Beproevingskooi",
  "block.minecraft.tripwire": "Struikeldraad",
  "block.minecraft.tripwire_hook": "Struikeldraadhaak",
  "block.minecraft.tube_coral": "Buiskoraal",
  "block.minecraft.tube_coral_block": "Buiskoraalblok",
  "block.minecraft.tube_coral_fan": "Buiskoraalwaaier",
  "block.minecraft.tube_coral_wall_fan": "Buiskoraalwaaier aan muur",
  "block.minecraft.tuff": "Tufsteen",
  "block.minecraft.tuff_brick_slab": "Tufstenen blokstenen plaat",
  "block.minecraft.tuff_brick_stairs": "Tufstenen blokstenen trap",
  "block.minecraft.tuff_brick_wall": "Tufstenen blokstenen muur",
  "block.minecraft.tuff_bricks": "Tufstenen blokstenen",
  "block.minecraft.tuff_slab": "Tufstenen plaat",
  "block.minecraft.tuff_stairs": "Tufstenen trap",
  "block.minecraft.tuff_wall": "Tufstenen muur",
  "block.minecraft.turtle_egg": "Schildpadei",
  "block.minecraft.twisting_vines": "Verwikkelde klimop",
  "block.minecraft.twisting_vines_plant": "Verwikkelde klimplant",
  "block.minecraft.vault": "Kluis",
  "block.minecraft.verdant_froglight": "Groen kikkerlicht",
  "block.minecraft.vine": "Lianen",
  "block.minecraft.void_air": "Leegtelucht",
  "block.minecraft.wall_torch": "Fakkel aan muur",
  "block.minecraft.warped_button": "Spookachtige houten knop",
  "block.minecraft.warped_door": "Spookachtige houten deur",
  "block.minecraft.warped_fence": "Spookachtig houten hek",
  "block.minecraft.warped_fence_gate": "Spookachtige houten poort",
  "block.minecraft.warped_fungus": "Spookachtige zwam",
  "block.minecraft.warped_hanging_sign": "Spookachtig houten hangbord",
  "block.minecraft.warped_hyphae": "Spookachtige schimmeldraden",
  "block.minecraft.warped_nylium": "Spookachtig nylium",
  "block.minecraft.warped_planks": "Spookachtige houten planken",
  "block.minecraft.warped_pressure_plate": "Spookachtige houten drukplaat",
  "block.minecraft.warped_roots": "Spookachtige wortels",
  "block.minecraft.warped_shelf": "Spookachtig houten schap",
  "block.minecraft.warped_sign": "Spookachtig houten bord",
  "block.minecraft.warped_slab": "Spookachtige houten plaat",
  "block.minecraft.warped_stairs": "Spookachtige houten trap",
  "block.minecraft.warped_stem": "Spookachtige stam",
  "block.minecraft.warped_trapdoor": "Spookachtig houten valluik",
  "block.minecraft.warped_wall_hanging_sign": "Spookachtig houten uithangbord",
  "block.minecraft.warped_wall_sign": "Spookachtig houten bord aan muur",
  "block.minecraft.warped_wart_block": "Spookachtig kruidblok",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Ketel met water",
  "block.minecraft.waxed_chiseled_copper": "Ingewassen bewerkt koperblok",
  "block.minecraft.waxed_copper_bars": "Ingewassen koperen tralies",
  "block.minecraft.waxed_copper_block": "Ingewassen koperblok",
  "block.minecraft.waxed_copper_bulb": "Ingewassen koperen lamp",
  "block.minecraft.waxed_copper_chain": "Ingewassen koperen ketting",
  "block.minecraft.waxed_copper_chest": "Ingewassen koperen kist",
  "block.minecraft.waxed_copper_door": "Ingewassen koperen deur",
  "block.minecraft.waxed_copper_golem_statue": "Ingewassen kopergolemstandbeeld",
  "block.minecraft.waxed_copper_grate": "Ingewassen koperen rooster",
  "block.minecraft.waxed_copper_lantern": "Ingewassen koperen lantaarn",
  "block.minecraft.waxed_copper_trapdoor": "Ingewassen koperen valluik",
  "block.minecraft.waxed_cut_copper": "Ingewassen gesneden koperblok",
  "block.minecraft.waxed_cut_copper_slab": "Ingewassen gesneden koperen plaat",
  "block.minecraft.waxed_cut_copper_stairs": "Ingewassen gesneden koperen trap",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ingewassen blootgesteld bewerkt koperblok",
  "block.minecraft.waxed_exposed_copper": "Ingewassen blootgesteld koperblok",
  "block.minecraft.waxed_exposed_copper_bars": "Ingewassen blootgestelde koperen tralies",
  "block.minecraft.waxed_exposed_copper_bulb": "Ingewassen blootgestelde koperen lamp",
  "block.minecraft.waxed_exposed_copper_chain": "Ingewassen blootgestelde koperen ketting",
  "block.minecraft.waxed_exposed_copper_chest": "Ingewassen blootgestelde koperen kist",
  "block.minecraft.waxed_exposed_copper_door": "Ingewassen blootgestelde koperen deur",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Ingewassen blootgesteld kopergolemstandbeeld",
  "block.minecraft.waxed_exposed_copper_grate": "Ingewassen blootgesteld koperen rooster",
  "block.minecraft.waxed_exposed_copper_lantern": "Ingewassen blootgestelde koperen lantaarn",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ingewassen blootgesteld koperen valluik",
  "block.minecraft.waxed_exposed_cut_copper": "Ingewassen blootgesteld gesneden koperblok",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ingewassen blootgestelde gesneden koperen plaat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ingewassen blootgestelde gesneden koperen trap",
  "block.minecraft.waxed_exposed_lightning_rod": "Ingewassen blootgestelde bliksemafleider",
  "block.minecraft.waxed_lightning_rod": "Ingewassen bliksemafleider",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ingewassen geoxideerd bewerkt koperblok",
  "block.minecraft.waxed_oxidized_copper": "Ingewassen geoxideerd koperblok",
  "block.minecraft.waxed_oxidized_copper_bars": "Ingewassen geoxideerde koperen tralies",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ingewassen geoxideerde koperen lamp",
  "block.minecraft.waxed_oxidized_copper_chain": "Ingewassen geoxideerde koperen ketting",
  "block.minecraft.waxed_oxidized_copper_chest": "Ingewassen geoxideerde koperen kist",
  "block.minecraft.waxed_oxidized_copper_door": "Ingewassen geoxideerde koperen deur",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Ingewassen geoxideerd kopergolemstandbeeld",
  "block.minecraft.waxed_oxidized_copper_grate": "Ingewassen geoxideerd koperen rooster",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ingewassen geoxideerde koperen lantaarn",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ingewassen geoxideerd koperen valluik",
  "block.minecraft.waxed_oxidized_cut_copper": "Ingewassen geoxideerd gesneden koperblok",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ingewassen geoxideerde gesneden koperen plaat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ingewassen geoxideerde gesneden koperen trap",
  "block.minecraft.waxed_oxidized_lightning_rod": "Ingewassen geoxideerde bliksemafleider",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ingewassen verweerd bewerkt koperblok",
  "block.minecraft.waxed_weathered_copper": "Ingewassen verweerd koperblok",
  "block.minecraft.waxed_weathered_copper_bars": "Ingewassen verweerde koperen tralies",
  "block.minecraft.waxed_weathered_copper_bulb": "Ingewassen verweerde koperen lamp",
  "block.minecraft.waxed_weathered_copper_chain": "Ingewassen verweerde koperen ketting",
  "block.minecraft.waxed_weathered_copper_chest": "Ingewassen verweerde koperen kist",
  "block.minecraft.waxed_weathered_copper_door": "Ingewassen verweerde koperen deur",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Ingewassen verweerd kopergolemstandbeeld",
  "block.minecraft.waxed_weathered_copper_grate": "Ingewassen verweerd koperen rooster",
  "block.minecraft.waxed_weathered_copper_lantern": "Ingewassen verweerde koperen lantaarn",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ingewassen verweerd koperen valluik",
  "block.minecraft.waxed_weathered_cut_copper": "Ingewassen verweerd gesneden koperblok",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ingewassen verweerde gesneden koperen plaat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ingewassen verweerde gesneden koperen trap",
  "block.minecraft.waxed_weathered_lightning_rod": "Ingewassen verweerde bliksemafleider",
  "block.minecraft.weathered_chiseled_copper": "Verweerd bewerkt koperblok",
  "block.minecraft.weathered_copper": "Verweerd koperblok",
  "block.minecraft.weathered_copper_bars": "Verweerde koperen tralies",
  "block.minecraft.weathered_copper_bulb": "Verweerde koperen lamp",
  "block.minecraft.weathered_copper_chain": "Verweerde koperen ketting",
  "block.minecraft.weathered_copper_chest": "Verweerde koperen kist",
  "block.minecraft.weathered_copper_door": "Verweerde koperen deur",
  "block.minecraft.weathered_copper_golem_statue": "Verweerd kopergolemstandbeeld",
  "block.minecraft.weathered_copper_grate": "Verweerd koperen rooster",
  "block.minecraft.weathered_copper_lantern": "Verweerde koperen lantaarn",
  "block.minecraft.weathered_copper_trapdoor": "Verweerd koperen valluik",
  "block.minecraft.weathered_cut_copper": "Verweerd gesneden koperblok",
  "block.minecraft.weathered_cut_copper_slab": "Verweerde gesneden koperen plaat",
  "block.minecraft.weathered_cut_copper_stairs": "Verweerde gesneden koperen trap",
  "block.minecraft.weathered_lightning_rod": "Verweerde bliksemafleider",
  "block.minecraft.weeping_vines": "Hangende klimop",
  "block.minecraft.weeping_vines_plant": "Hangende klimplant",
  "block.minecraft.wet_sponge": "Natte spons",
  "block.minecraft.wheat": "Tarwe",
  "block.minecraft.white_banner": "Witte banier",
  "block.minecraft.white_bed": "Wit bed",
  "block.minecraft.white_candle": "Witte kaars",
  "block.minecraft.white_candle_cake": "Taart met witte kaars",
  "block.minecraft.white_carpet": "Wit tapijt",
  "block.minecraft.white_concrete": "Wit beton",
  "block.minecraft.white_concrete_powder": "Wit cement",
  "block.minecraft.white_glazed_terracotta": "Witgeglazuurd terracotta",
  "block.minecraft.white_shulker_box": "Witte Shulkerdoos",
  "block.minecraft.white_stained_glass": "Witgekleurd glas",
  "block.minecraft.white_stained_glass_pane": "Witgekleurde glazen ruit",
  "block.minecraft.white_terracotta": "Wit terracotta",
  "block.minecraft.white_tulip": "Witte tulp",
  "block.minecraft.white_wool": "Witte wol",
  "block.minecraft.wildflowers": "Wilde bloemen",
  "block.minecraft.wither_rose": "Witherroos",
  "block.minecraft.wither_skeleton_skull": "Witherskelettenschedel",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelettenschedel aan muur",
  "block.minecraft.yellow_banner": "Gele banier",
  "block.minecraft.yellow_bed": "Geel bed",
  "block.minecraft.yellow_candle": "Gele kaars",
  "block.minecraft.yellow_candle_cake": "Taart met gele kaars",
  "block.minecraft.yellow_carpet": "Geel tapijt",
  "block.minecraft.yellow_concrete": "Geel beton",
  "block.minecraft.yellow_concrete_powder": "Geel cement",
  "block.minecraft.yellow_glazed_terracotta": "Geelgeglazuurd terracotta",
  "block.minecraft.yellow_shulker_box": "Gele Shulkerdoos",
  "block.minecraft.yellow_stained_glass": "Geelgekleurd glas",
  "block.minecraft.yellow_stained_glass_pane": "Geelgekleurde glazen ruit",
  "block.minecraft.yellow_terracotta": "Geel terracotta",
  "block.minecraft.yellow_wool": "Gele wol",
  "block.minecraft.zombie_head": "Zombiehoofd",
  "block.minecraft.zombie_wall_head": "Zombiehoofd aan muur",
  "item.minecraft.acacia_boat": "Acaciahouten boot",
  "item.minecraft.acacia_chest_boat": "Acaciahouten boot met kist",
  "item.minecraft.allay_spawn_egg": "Helperspawnei",
  "item.minecraft.amethyst_shard": "Amethistscherf",
  "item.minecraft.angler_pottery_shard": "Aardewerkscherf 'visser'",
  "item.minecraft.angler_pottery_sherd": "Aardewerkscherf 'visser'",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.archer_pottery_sherd": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.armadillo_scute": "Gordeldierhoornplaat",
  "item.minecraft.armadillo_spawn_egg": "Gordeldierenspawnei",
  "item.minecraft.armor_stand": "Harnashouder",
  "item.minecraft.arms_up_pottery_shard": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.arms_up_pottery_sherd": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.arrow": "Pijl",
  "item.minecraft.axolotl_bucket": "Emmer axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotlspawnei",
  "item.minecraft.baked_potato": "Gebakken aardappel",
  "item.minecraft.bamboo_chest_raft": "Bamboevlot met kist",
  "item.minecraft.bamboo_raft": "Bamboevlot",
  "item.minecraft.bat_spawn_egg": "Vleermuizenspawnei",
  "item.minecraft.bee_spawn_egg": "Bijenspawnei",
  "item.minecraft.beef": "Rauwe biefstuk",
  "item.minecraft.beetroot": "Biet",
  "item.minecraft.beetroot_seeds": "Bietenzaden",
  "item.minecraft.beetroot_soup": "Bietensoep",
  "item.minecraft.birch_boat": "Berkenhouten boot",
  "item.minecraft.birch_chest_boat": "Berkenhouten boot met kist",
  "item.minecraft.black_bundle": "Zwarte bundel",
  "item.minecraft.black_dye": "Zwarte kleurstof",
  "item.minecraft.black_harness": "Zwart tuig",
  "item.minecraft.blade_pottery_shard": "Aardewerkscherf 'zwaard'",
  "item.minecraft.blade_pottery_sherd": "Aardewerkscherf 'zwaard'",
  "item.minecraft.blaze_powder": "Blazepoeder",
  "item.minecraft.blaze_rod": "Blazestaf",
  "item.minecraft.blaze_spawn_egg": "Blazespawnei",
  "item.minecraft.blue_bundle": "Blauwe bundel",
  "item.minecraft.blue_dye": "Blauwe kleurstof",
  "item.minecraft.blue_egg": "Blauw ei",
  "item.minecraft.blue_harness": "Blauw tuig",
  "item.minecraft.bogged_spawn_egg": "Zomperspawnei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Harnasversiering 'bout'",
  "item.minecraft.bone": "Bot",
  "item.minecraft.bone_meal": "Beendermeel",
  "item.minecraft.book": "Boek",
  "item.minecraft.bordure_indented_banner_pattern": "Ingesprongenzoombanierpatroon",
  "item.minecraft.bow": "Boog",
  "item.minecraft.bowl": "Kom",
  "item.minecraft.bread": "Brood",
  "item.minecraft.breeze_rod": "Vlaagstaf",
  "item.minecraft.breeze_spawn_egg": "Vlagenspawnei",
  "item.minecraft.brewer_pottery_shard": "Aardewerkscherf 'brouwer'",
  "item.minecraft.brewer_pottery_sherd": "Aardewerkscherf 'brouwer'",
  "item.minecraft.brewing_stand": "Brouwstandaard",
  "item.minecraft.brick": "Baksteen",
  "item.minecraft.brown_bundle": "Bruine bundel",
  "item.minecraft.brown_dye": "Bruine kleurstof",
  "item.minecraft.brown_egg": "Bruin ei",
  "item.minecraft.brown_harness": "Bruin tuig",
  "item.minecraft.brush": "Borstel",
  "item.minecraft.bucket": "Emmer",
  "item.minecraft.bundle": "Bundel",
  "item.minecraft.bundle.empty": "Leeg",
  "item.minecraft.bundle.empty.description": "Kan een stapel van verschillende voorwerpen vasthouden",
  "item.minecraft.bundle.full": "Vol",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Aardewerkscherf 'branden'",
  "item.minecraft.burn_pottery_sherd": "Aardewerkscherf 'branden'",
  "item.minecraft.camel_husk_spawn_egg": "Dromedarismummiespawnei",
  "item.minecraft.camel_spawn_egg": "Dromedarisspawnei",
  "item.minecraft.carrot": "Wortel",
  "item.minecraft.carrot_on_a_stick": "Wortel aan een stok",
  "item.minecraft.cat_spawn_egg": "Kattenspawnei",
  "item.minecraft.cauldron": "Ketel",
  "item.minecraft.cave_spider_spawn_egg": "Grottenspinnenspawnei",
  "item.minecraft.chainmail_boots": "Maliënlaarzen",
  "item.minecraft.chainmail_chestplate": "Maliënkolder",
  "item.minecraft.chainmail_helmet": "Maliënkap",
  "item.minecraft.chainmail_leggings": "Maliënbroek",
  "item.minecraft.charcoal": "Houtskool",
  "item.minecraft.cherry_boat": "Kersenhouten boot",
  "item.minecraft.cherry_chest_boat": "Kersenhouten boot met kist",
  "item.minecraft.chest_minecart": "Mijnkar met kist",
  "item.minecraft.chicken": "Rauwe kip",
  "item.minecraft.chicken_spawn_egg": "Kippenspawnei",
  "item.minecraft.chorus_fruit": "Chorusfruit",
  "item.minecraft.clay_ball": "Kleibal",
  "item.minecraft.clock": "Klok",
  "item.minecraft.coal": "Steenkool",
  "item.minecraft.coast_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Harnasversiering 'kust'",
  "item.minecraft.cocoa_beans": "Cacaobonen",
  "item.minecraft.cod": "Rauwe kabeljauw",
  "item.minecraft.cod_bucket": "Emmer kabeljauw",
  "item.minecraft.cod_spawn_egg": "Kabeljauwspawnei",
  "item.minecraft.command_block_minecart": "Mijnkar met opdrachtblok",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Biefstuk",
  "item.minecraft.cooked_chicken": "Gebraden kip",
  "item.minecraft.cooked_cod": "Gebakken kabeljauw",
  "item.minecraft.cooked_mutton": "Gebraden schapenvlees",
  "item.minecraft.cooked_porkchop": "Gebraden varkensvlees",
  "item.minecraft.cooked_rabbit": "Gebraden konijnenvlees",
  "item.minecraft.cooked_salmon": "Gebakken zalm",
  "item.minecraft.cookie": "Koekje",
  "item.minecraft.copper_axe": "Koperen bijl",
  "item.minecraft.copper_boots": "Koperen laarzen",
  "item.minecraft.copper_chestplate": "Koperen borstplaat",
  "item.minecraft.copper_golem_spawn_egg": "Kopergolemspawnei",
  "item.minecraft.copper_helmet": "Koperen helm",
  "item.minecraft.copper_hoe": "Koperen schoffel",
  "item.minecraft.copper_horse_armor": "Koperen paardenharnas",
  "item.minecraft.copper_ingot": "Koperstaaf",
  "item.minecraft.copper_leggings": "Koperen beenstukken",
  "item.minecraft.copper_nautilus_armor": "Koperen nautilusharnas",
  "item.minecraft.copper_nugget": "Koperklompje",
  "item.minecraft.copper_pickaxe": "Koperen houweel",
  "item.minecraft.copper_shovel": "Koperen schep",
  "item.minecraft.copper_spear": "Koperen speer",
  "item.minecraft.copper_sword": "Koperen zwaard",
  "item.minecraft.cow_spawn_egg": "Koeienspawnei",
  "item.minecraft.creaking_spawn_egg": "Schorswakerspawnei",
  "item.minecraft.creeper_banner_pattern": "Banierpatroon",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperwapen",
  "item.minecraft.creeper_banner_pattern.new": "Creeperwapenbanierpatroon",
  "item.minecraft.creeper_spawn_egg": "Creeperspawnei",
  "item.minecraft.crossbow": "Kruisboog",
  "item.minecraft.crossbow.projectile": "Projectiel:",
  "item.minecraft.crossbow.projectile.multiple": "Projectiel: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Projectiel: %s",
  "item.minecraft.cyan_bundle": "Turquoise bundel",
  "item.minecraft.cyan_dye": "Turquoise kleurstof",
  "item.minecraft.cyan_harness": "Turquoise tuig",
  "item.minecraft.danger_pottery_shard": "Aardewerkscherf 'gevaar'",
  "item.minecraft.danger_pottery_sherd": "Aardewerkscherf 'gevaar'",
  "item.minecraft.dark_oak_boat": "Donkere eikenhouten boot",
  "item.minecraft.dark_oak_chest_boat": "Donkere eikenhouten boot met kist",
  "item.minecraft.debug_stick": "Debugstok",
  "item.minecraft.debug_stick.empty": "%s heeft geen eigenschappen",
  "item.minecraft.debug_stick.select": "'%s' geselecteerd (%s)",
  "item.minecraft.debug_stick.update": "'%s' naar %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamanten bijl",
  "item.minecraft.diamond_boots": "Diamanten laarzen",
  "item.minecraft.diamond_chestplate": "Diamanten kuras",
  "item.minecraft.diamond_helmet": "Diamanten helm",
  "item.minecraft.diamond_hoe": "Diamanten schoffel",
  "item.minecraft.diamond_horse_armor": "Diamanten paardenharnas",
  "item.minecraft.diamond_leggings": "Diamanten beenstukken",
  "item.minecraft.diamond_nautilus_armor": "Diamanten nautilusharnas",
  "item.minecraft.diamond_pickaxe": "Diamanten houweel",
  "item.minecraft.diamond_shovel": "Diamanten schep",
  "item.minecraft.diamond_spear": "Diamanten speer",
  "item.minecraft.diamond_sword": "Diamanten zwaard",
  "item.minecraft.disc_fragment_5": "Muziekplaatfragment",
  "item.minecraft.disc_fragment_5.desc": "Muziekplaat - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "Ezelspawnei",
  "item.minecraft.dragon_breath": "Drakenadem",
  "item.minecraft.dried_kelp": "Gedroogde kelp",
  "item.minecraft.drowned_spawn_egg": "Drenkelingenspawnei",
  "item.minecraft.dune_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Harnasversiering 'duin'",
  "item.minecraft.echo_shard": "Echoscherf",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Oudebewakerspawnei",
  "item.minecraft.elytra": "Dekschild",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Betoverd boek",
  "item.minecraft.enchanted_golden_apple": "Betoverde gouden appel",
  "item.minecraft.end_crystal": "Endkristal",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrakenspawnei",
  "item.minecraft.ender_eye": "Enderoog",
  "item.minecraft.ender_pearl": "Enderparel",
  "item.minecraft.enderman_spawn_egg": "Endermannenspawnei",
  "item.minecraft.endermite_spawn_egg": "Endermijtspawnei",
  "item.minecraft.evoker_spawn_egg": "Oproeperspawnei",
  "item.minecraft.experience_bottle": "Magiërsextract",
  "item.minecraft.explorer_pottery_shard": "Aardewerkscherf 'ontdekker'",
  "item.minecraft.explorer_pottery_sherd": "Aardewerkscherf 'ontdekker'",
  "item.minecraft.eye_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Harnasversiering 'oog'",
  "item.minecraft.feather": "Veer",
  "item.minecraft.fermented_spider_eye": "Gefermenteerd spinnenoog",
  "item.minecraft.field_masoned_banner_pattern": "Metselwerkbanierpatroon",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Vuurbal",
  "item.minecraft.firework_rocket": "Vuurpijl",
  "item.minecraft.firework_rocket.flight": "Vluchtduur:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vuurwerkster",
  "item.minecraft.firework_star.black": "Zwart",
  "item.minecraft.firework_star.blue": "Blauw",
  "item.minecraft.firework_star.brown": "Bruin",
  "item.minecraft.firework_star.custom_color": "Aangepast",
  "item.minecraft.firework_star.cyan": "Turquoise",
  "item.minecraft.firework_star.fade_to": "Overgang naar",
  "item.minecraft.firework_star.flicker": "Twinkel",
  "item.minecraft.firework_star.gray": "Grijs",
  "item.minecraft.firework_star.green": "Groen",
  "item.minecraft.firework_star.light_blue": "Lichtblauw",
  "item.minecraft.firework_star.light_gray": "Lichtgrijs",
  "item.minecraft.firework_star.lime": "Lichtgroen",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Roze",
  "item.minecraft.firework_star.purple": "Paars",
  "item.minecraft.firework_star.red": "Rood",
  "item.minecraft.firework_star.shape": "Onbekende vorm",
  "item.minecraft.firework_star.shape.burst": "Explosie",
  "item.minecraft.firework_star.shape.creeper": "Creepervormig",
  "item.minecraft.firework_star.shape.large_ball": "Grote bal",
  "item.minecraft.firework_star.shape.small_ball": "Kleine bal",
  "item.minecraft.firework_star.shape.star": "Stervormig",
  "item.minecraft.firework_star.trail": "Spoor",
  "item.minecraft.firework_star.white": "Wit",
  "item.minecraft.firework_star.yellow": "Geel",
  "item.minecraft.fishing_rod": "Vishengel",
  "item.minecraft.flint": "Vuursteen",
  "item.minecraft.flint_and_steel": "Vuursteen en staal",
  "item.minecraft.flow_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Harnasversiering 'windstroming'",
  "item.minecraft.flow_banner_pattern": "Banierpatroon",
  "item.minecraft.flow_banner_pattern.desc": "Windstroming",
  "item.minecraft.flow_banner_pattern.new": "Windstromingbanierpatroon",
  "item.minecraft.flow_pottery_sherd": "Aardewerkscherf 'windstroming'",
  "item.minecraft.flower_banner_pattern": "Banierpatroon",
  "item.minecraft.flower_banner_pattern.desc": "Bloemwapen",
  "item.minecraft.flower_banner_pattern.new": "Bloemwapenbanierpatroon",
  "item.minecraft.flower_pot": "Bloempot",
  "item.minecraft.fox_spawn_egg": "Vossenspawnei",
  "item.minecraft.friend_pottery_shard": "Aardewerkscherf 'vriend'",
  "item.minecraft.friend_pottery_sherd": "Aardewerkscherf 'vriend'",
  "item.minecraft.frog_spawn_egg": "Kikkerspawnei",
  "item.minecraft.furnace_minecart": "Mijnkar met oven",
  "item.minecraft.ghast_spawn_egg": "Ghastspawnei",
  "item.minecraft.ghast_tear": "Ghasttraan",
  "item.minecraft.glass_bottle": "Glazen fles",
  "item.minecraft.glistering_melon_slice": "Glinsterende meloenschijf",
  "item.minecraft.globe_banner_pattern": "Banierpatroon",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Globebanierpatroon",
  "item.minecraft.glow_berries": "Gloeibessen",
  "item.minecraft.glow_ink_sac": "Gloeiende inktzak",
  "item.minecraft.glow_item_frame": "Gloeiende voorwerplijst",
  "item.minecraft.glow_squid_spawn_egg": "Gloeiendeinktvissenspawnei",
  "item.minecraft.glowstone_dust": "Gloeisteenstof",
  "item.minecraft.goat_horn": "Geitenhoorn",
  "item.minecraft.goat_spawn_egg": "Geitenspawnei",
  "item.minecraft.gold_ingot": "Goudstaaf",
  "item.minecraft.gold_nugget": "Goudklompje",
  "item.minecraft.golden_apple": "Gouden appel",
  "item.minecraft.golden_axe": "Gouden bijl",
  "item.minecraft.golden_boots": "Gouden laarzen",
  "item.minecraft.golden_carrot": "Gouden wortel",
  "item.minecraft.golden_chestplate": "Gouden kuras",
  "item.minecraft.golden_helmet": "Gouden helm",
  "item.minecraft.golden_hoe": "Gouden schoffel",
  "item.minecraft.golden_horse_armor": "Gouden paardenharnas",
  "item.minecraft.golden_leggings": "Gouden beenstukken",
  "item.minecraft.golden_nautilus_armor": "Gouden nautilusharnas",
  "item.minecraft.golden_pickaxe": "Gouden houweel",
  "item.minecraft.golden_shovel": "Gouden schep",
  "item.minecraft.golden_spear": "Gouden speer",
  "item.minecraft.golden_sword": "Gouden zwaard",
  "item.minecraft.gray_bundle": "Grijze bundel",
  "item.minecraft.gray_dye": "Grijze kleurstof",
  "item.minecraft.gray_harness": "Grijs tuig",
  "item.minecraft.green_bundle": "Groene bundel",
  "item.minecraft.green_dye": "Groene kleurstof",
  "item.minecraft.green_harness": "Groen tuig",
  "item.minecraft.guardian_spawn_egg": "Bewakerspawnei",
  "item.minecraft.gunpowder": "Buskruit",
  "item.minecraft.guster_banner_pattern": "Banierpatroon",
  "item.minecraft.guster_banner_pattern.desc": "Rukwind",
  "item.minecraft.guster_banner_pattern.new": "Rukwindbanierpatroon",
  "item.minecraft.guster_pottery_sherd": "Aardewerkscherf 'rukwind'",
  "item.minecraft.happy_ghast_spawn_egg": "Vrolijkeghastspawnei",
  "item.minecraft.harness": "Tuig",
  "item.minecraft.heart_of_the_sea": "Hart van de zee",
  "item.minecraft.heart_pottery_shard": "Aardewerkscherf 'hart'",
  "item.minecraft.heart_pottery_sherd": "Aardewerkscherf 'hart'",
  "item.minecraft.heartbreak_pottery_shard": "Aardewerkscherf 'gebroken hart'",
  "item.minecraft.heartbreak_pottery_sherd": "Aardewerkscherf 'gebroken hart'",
  "item.minecraft.hoglin_spawn_egg": "Hoglinspawnei",
  "item.minecraft.honey_bottle": "Honingfles",
  "item.minecraft.honeycomb": "Honingraat",
  "item.minecraft.hopper_minecart": "Mijnkar met trechter",
  "item.minecraft.horse_spawn_egg": "Paardenspawnei",
  "item.minecraft.host_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Harnasversiering 'gastheer'",
  "item.minecraft.howl_pottery_shard": "Aardewerkscherf 'huilen'",
  "item.minecraft.howl_pottery_sherd": "Aardewerkscherf 'huilen'",
  "item.minecraft.husk_spawn_egg": "Mummiespawnei",
  "item.minecraft.ink_sac": "Inktzak",
  "item.minecraft.iron_axe": "IJzeren bijl",
  "item.minecraft.iron_boots": "IJzeren laarzen",
  "item.minecraft.iron_chestplate": "IJzeren kuras",
  "item.minecraft.iron_golem_spawn_egg": "IJzergolemspawnei",
  "item.minecraft.iron_helmet": "IJzeren helm",
  "item.minecraft.iron_hoe": "IJzeren schoffel",
  "item.minecraft.iron_horse_armor": "IJzeren paardenharnas",
  "item.minecraft.iron_ingot": "IJzerstaaf",
  "item.minecraft.iron_leggings": "IJzeren beenstukken",
  "item.minecraft.iron_nautilus_armor": "IJzeren nautilusharnas",
  "item.minecraft.iron_nugget": "IJzerklompje",
  "item.minecraft.iron_pickaxe": "IJzeren houweel",
  "item.minecraft.iron_shovel": "IJzeren schep",
  "item.minecraft.iron_spear": "IJzeren speer",
  "item.minecraft.iron_sword": "IJzeren zwaard",
  "item.minecraft.item_frame": "Voorwerplijst",
  "item.minecraft.jungle_boat": "Oerwoudhouten boot",
  "item.minecraft.jungle_chest_boat": "Oerwoudhouten boot met kist",
  "item.minecraft.knowledge_book": "Boek der kennis",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Emmer lava",
  "item.minecraft.lead": "Leidtouw",
  "item.minecraft.leather": "Leer",
  "item.minecraft.leather_boots": "Leren laarzen",
  "item.minecraft.leather_chestplate": "Leren tuniek",
  "item.minecraft.leather_helmet": "Leren kap",
  "item.minecraft.leather_horse_armor": "Leren paardenharnas",
  "item.minecraft.leather_leggings": "Leren broek",
  "item.minecraft.light_blue_bundle": "Lichtblauwe bundel",
  "item.minecraft.light_blue_dye": "Lichtblauwe kleurstof",
  "item.minecraft.light_blue_harness": "Lichtblauw tuig",
  "item.minecraft.light_gray_bundle": "Lichtgrijze bundel",
  "item.minecraft.light_gray_dye": "Lichtgrijze kleurstof",
  "item.minecraft.light_gray_harness": "Lichtgrijs tuig",
  "item.minecraft.lime_bundle": "Lichtgroene bundel",
  "item.minecraft.lime_dye": "Lichtgroene kleurstof",
  "item.minecraft.lime_harness": "Lichtgroen tuig",
  "item.minecraft.lingering_potion": "Aanhoudende drank",
  "item.minecraft.lingering_potion.effect.awkward": "Aanhoudende vreemde drank",
  "item.minecraft.lingering_potion.effect.empty": "Aanhoudende onmaakbare drank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Aanhoudende drank der vuurbestendigheid",
  "item.minecraft.lingering_potion.effect.harming": "Aanhoudende drank der verwonding",
  "item.minecraft.lingering_potion.effect.healing": "Aanhoudende drank der genezing",
  "item.minecraft.lingering_potion.effect.infested": "Aanhoudende drank der infestatie",
  "item.minecraft.lingering_potion.effect.invisibility": "Aanhoudende drank der onzichtbaarheid",
  "item.minecraft.lingering_potion.effect.leaping": "Aanhoudende drank der sprongen",
  "item.minecraft.lingering_potion.effect.levitation": "Aanhoudende drank der zweving",
  "item.minecraft.lingering_potion.effect.luck": "Aanhoudende drank des geluks",
  "item.minecraft.lingering_potion.effect.mundane": "Aanhoudende triviale drank",
  "item.minecraft.lingering_potion.effect.night_vision": "Aanhoudende drank des nachtzichts",
  "item.minecraft.lingering_potion.effect.oozing": "Aanhoudende drank der slijmerigheid",
  "item.minecraft.lingering_potion.effect.poison": "Aanhoudende drank des gifs",
  "item.minecraft.lingering_potion.effect.regeneration": "Aanhoudende drank der regeneratie",
  "item.minecraft.lingering_potion.effect.slow_falling": "Aanhoudende drank der valvertraging",
  "item.minecraft.lingering_potion.effect.slowness": "Aanhoudende drank der traagheid",
  "item.minecraft.lingering_potion.effect.strength": "Aanhoudende drank der kracht",
  "item.minecraft.lingering_potion.effect.swiftness": "Aanhoudende drank der vlotheid",
  "item.minecraft.lingering_potion.effect.thick": "Aanhoudende stroperige drank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Aanhoudende drank der schildpadmeester",
  "item.minecraft.lingering_potion.effect.water": "Aanhoudende waterfles",
  "item.minecraft.lingering_potion.effect.water_breathing": "Aanhoudende drank des wateradems",
  "item.minecraft.lingering_potion.effect.weakness": "Aanhoudende drank der zwakheid",
  "item.minecraft.lingering_potion.effect.weaving": "Aanhoudende drank der weven",
  "item.minecraft.lingering_potion.effect.wind_charged": "Aanhoudende drank des jagende winds",
  "item.minecraft.llama_spawn_egg": "Lamaspawnei",
  "item.minecraft.lodestone_compass": "Kompas wijzend naar zeilsteen",
  "item.minecraft.mace": "Knots",
  "item.minecraft.magenta_bundle": "Magenta bundel",
  "item.minecraft.magenta_dye": "Magenta kleurstof",
  "item.minecraft.magenta_harness": "Magenta tuig",
  "item.minecraft.magma_cream": "Magmacrème",
  "item.minecraft.magma_cube_spawn_egg": "Magmakubusspawnei",
  "item.minecraft.mangrove_boat": "Mangrovehouten boot",
  "item.minecraft.mangrove_chest_boat": "Mangrovehouten boot met kist",
  "item.minecraft.map": "Lege kaart",
  "item.minecraft.melon_seeds": "Meloenzaden",
  "item.minecraft.melon_slice": "Meloenschijf",
  "item.minecraft.milk_bucket": "Emmer melk",
  "item.minecraft.minecart": "Mijnkar",
  "item.minecraft.miner_pottery_shard": "Aardewerkscherf 'mijnwerker'",
  "item.minecraft.miner_pottery_sherd": "Aardewerkscherf 'mijnwerker'",
  "item.minecraft.mojang_banner_pattern": "Banierpatroon",
  "item.minecraft.mojang_banner_pattern.desc": "Mojanglogo",
  "item.minecraft.mojang_banner_pattern.new": "Mojanglogobanierpatroon",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomspawnei",
  "item.minecraft.mourner_pottery_shard": "Aardewerkscherf 'rouw'",
  "item.minecraft.mourner_pottery_sherd": "Aardewerkscherf 'rouw'",
  "item.minecraft.mule_spawn_egg": "Muilezelspawnei",
  "item.minecraft.mushroom_stew": "Paddenstoelenstoofpot",
  "item.minecraft.music_disc_11": "Muziekplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muziekplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muziekplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muziekplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muziekplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muziekplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muziekplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muziekplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Muziekplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muziekplaat",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muziekplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muziekplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muziekplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muziekplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muziekplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muziekplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muziekplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muziekplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muziekplaat",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muziekplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muziekplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rauw schapenvlees",
  "item.minecraft.name_tag": "Naamkaartje",
  "item.minecraft.nautilus_shell": "Nautilusschelp",
  "item.minecraft.nautilus_spawn_egg": "Nautilusspawnei",
  "item.minecraft.nether_brick": "Netherbaksteen",
  "item.minecraft.nether_star": "Netherster",
  "item.minecraft.nether_wart": "Netherkruid",
  "item.minecraft.netherite_axe": "Netherieten bijl",
  "item.minecraft.netherite_boots": "Netherieten laarzen",
  "item.minecraft.netherite_chestplate": "Netherieten kuras",
  "item.minecraft.netherite_helmet": "Netherieten helm",
  "item.minecraft.netherite_hoe": "Netherieten schoffel",
  "item.minecraft.netherite_horse_armor": "Netherieten paardenharnas",
  "item.minecraft.netherite_ingot": "Netherietstaaf",
  "item.minecraft.netherite_leggings": "Netherieten beenstukken",
  "item.minecraft.netherite_nautilus_armor": "Netherieten nautilusharnas",
  "item.minecraft.netherite_pickaxe": "Netherieten houweel",
  "item.minecraft.netherite_scrap": "Netherietschroot",
  "item.minecraft.netherite_shovel": "Netherieten schep",
  "item.minecraft.netherite_spear": "Netherieten speer",
  "item.minecraft.netherite_sword": "Netherieten zwaard",
  "item.minecraft.netherite_upgrade_smithing_template": "Smeedssjabloon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherietupgrade",
  "item.minecraft.oak_boat": "Eikenhouten boot",
  "item.minecraft.oak_chest_boat": "Eikenhouten boot met kist",
  "item.minecraft.ocelot_spawn_egg": "Ocelottenspawnei",
  "item.minecraft.ominous_bottle": "Onheilspellende fles",
  "item.minecraft.ominous_trial_key": "Onheilspellende beproevingssleutel",
  "item.minecraft.orange_bundle": "Oranje bundel",
  "item.minecraft.orange_dye": "Oranje kleurstof",
  "item.minecraft.orange_harness": "Oranje tuig",
  "item.minecraft.painting": "Schilderij",
  "item.minecraft.pale_oak_boat": "Bleke eikenhouten boot",
  "item.minecraft.pale_oak_chest_boat": "Bleke eikenhouten boot met kist",
  "item.minecraft.panda_spawn_egg": "Pandaspawnei",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Zorenspawnei",
  "item.minecraft.parrot_spawn_egg": "Papegaaienspawnei",
  "item.minecraft.phantom_membrane": "Fantoommembraan",
  "item.minecraft.phantom_spawn_egg": "Fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "Varkensspawnei",
  "item.minecraft.piglin_banner_pattern": "Banierpatroon",
  "item.minecraft.piglin_banner_pattern.desc": "Snuit",
  "item.minecraft.piglin_banner_pattern.new": "Snoetbanierpatroon",
  "item.minecraft.piglin_brute_spawn_egg": "Piglinbruutspawnei",
  "item.minecraft.piglin_spawn_egg": "Piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "Roverspawnei",
  "item.minecraft.pink_bundle": "Roze bundel",
  "item.minecraft.pink_dye": "Roze kleurstof",
  "item.minecraft.pink_harness": "Roze tuig",
  "item.minecraft.pitcher_plant": "Bekerplant",
  "item.minecraft.pitcher_pod": "Bekerplantpeul",
  "item.minecraft.plenty_pottery_shard": "Aardewerkscherf 'overvloed'",
  "item.minecraft.plenty_pottery_sherd": "Aardewerkscherf 'overvloed'",
  "item.minecraft.poisonous_potato": "Giftige aardappel",
  "item.minecraft.polar_bear_spawn_egg": "IJsberenspawnei",
  "item.minecraft.popped_chorus_fruit": "Gepoft chorusfruit",
  "item.minecraft.porkchop": "Rauw varkensvlees",
  "item.minecraft.potato": "Aardappel",
  "item.minecraft.potion": "Drank",
  "item.minecraft.potion.effect.awkward": "Vreemde drank",
  "item.minecraft.potion.effect.empty": "Onmaakbare drank",
  "item.minecraft.potion.effect.fire_resistance": "Drank der vuurbestendigheid",
  "item.minecraft.potion.effect.harming": "Drank der verwonding",
  "item.minecraft.potion.effect.healing": "Drank der genezing",
  "item.minecraft.potion.effect.infested": "Drank der infestatie",
  "item.minecraft.potion.effect.invisibility": "Drank der onzichtbaarheid",
  "item.minecraft.potion.effect.leaping": "Drank der sprongen",
  "item.minecraft.potion.effect.levitation": "Drank der zweving",
  "item.minecraft.potion.effect.luck": "Drank des geluks",
  "item.minecraft.potion.effect.mundane": "Triviale drank",
  "item.minecraft.potion.effect.night_vision": "Drank des nachtzichts",
  "item.minecraft.potion.effect.oozing": "Drank der slijmerigheid",
  "item.minecraft.potion.effect.poison": "Drank des gifs",
  "item.minecraft.potion.effect.regeneration": "Drank der regeneratie",
  "item.minecraft.potion.effect.slow_falling": "Drank der valvertraging",
  "item.minecraft.potion.effect.slowness": "Drank der traagheid",
  "item.minecraft.potion.effect.strength": "Drank der kracht",
  "item.minecraft.potion.effect.swiftness": "Drank der vlotheid",
  "item.minecraft.potion.effect.thick": "Stroperige drank",
  "item.minecraft.potion.effect.turtle_master": "Drank der schildpadmeester",
  "item.minecraft.potion.effect.water": "Waterfles",
  "item.minecraft.potion.effect.water_breathing": "Drank des wateradems",
  "item.minecraft.potion.effect.weakness": "Drank der zwakheid",
  "item.minecraft.potion.effect.weaving": "Drank der weven",
  "item.minecraft.potion.effect.wind_charged": "Drank des jagende winds",
  "item.minecraft.pottery_shard_archer": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.pottery_shard_arms_up": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.pottery_shard_prize": "Aardewerkscherf 'prijs'",
  "item.minecraft.pottery_shard_skull": "Aardewerkscherf 'schedel'",
  "item.minecraft.powder_snow_bucket": "Emmer poedersneeuw",
  "item.minecraft.prismarine_crystals": "Prismarienkristallen",
  "item.minecraft.prismarine_shard": "Prismarienscherf",
  "item.minecraft.prize_pottery_shard": "Aardewerkscherf 'prijs'",
  "item.minecraft.prize_pottery_sherd": "Aardewerkscherf 'prijs'",
  "item.minecraft.pufferfish": "Kogelvis",
  "item.minecraft.pufferfish_bucket": "Emmer kogelvis",
  "item.minecraft.pufferfish_spawn_egg": "Kogelvissenspawnei",
  "item.minecraft.pumpkin_pie": "Pompoentaart",
  "item.minecraft.pumpkin_seeds": "Pompoenpitten",
  "item.minecraft.purple_bundle": "Paarse bundel",
  "item.minecraft.purple_dye": "Paarse kleurstof",
  "item.minecraft.purple_harness": "Paars tuig",
  "item.minecraft.quartz": "Netherkwarts",
  "item.minecraft.rabbit": "Rauw konijnenvlees",
  "item.minecraft.rabbit_foot": "Konijnenpootje",
  "item.minecraft.rabbit_hide": "Konijnenhuid",
  "item.minecraft.rabbit_spawn_egg": "Konijnenspawnei",
  "item.minecraft.rabbit_stew": "Konijnenstoofpot",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Harnasversiering 'fokker'",
  "item.minecraft.ravager_spawn_egg": "Verwoesterspawnei",
  "item.minecraft.raw_copper": "Ruw koper",
  "item.minecraft.raw_gold": "Ruw goud",
  "item.minecraft.raw_iron": "Ruw ijzer",
  "item.minecraft.recovery_compass": "Herstelkompas",
  "item.minecraft.red_bundle": "Rode bundel",
  "item.minecraft.red_dye": "Rode kleurstof",
  "item.minecraft.red_harness": "Rood tuig",
  "item.minecraft.redstone": "Redstonestof",
  "item.minecraft.resin_brick": "Harsbaksteen",
  "item.minecraft.resin_clump": "Harsdruppel",
  "item.minecraft.rib_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Harnasversiering 'rib'",
  "item.minecraft.rotten_flesh": "Bedorven vlees",
  "item.minecraft.saddle": "Zadel",
  "item.minecraft.salmon": "Rauwe zalm",
  "item.minecraft.salmon_bucket": "Emmer zalm",
  "item.minecraft.salmon_spawn_egg": "Zalmspawnei",
  "item.minecraft.scrape_pottery_sherd": "Aardewerkscherf 'schrapen'",
  "item.minecraft.scute": "Hoornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Harnasversiering 'schildwacht'",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Harnasversiering 'vormer'",
  "item.minecraft.sheaf_pottery_shard": "Aardewerkscherf 'schoof'",
  "item.minecraft.sheaf_pottery_sherd": "Aardewerkscherf 'schoof'",
  "item.minecraft.shears": "Schaar",
  "item.minecraft.sheep_spawn_egg": "Schapenspawnei",
  "item.minecraft.shelter_pottery_shard": "Aardewerkscherf 'schuilplaats'",
  "item.minecraft.shelter_pottery_sherd": "Aardewerkscherf 'schuilplaats'",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Zwart schild",
  "item.minecraft.shield.blue": "Blauw schild",
  "item.minecraft.shield.brown": "Bruin schild",
  "item.minecraft.shield.cyan": "Turquoise schild",
  "item.minecraft.shield.gray": "Grijs schild",
  "item.minecraft.shield.green": "Groen schild",
  "item.minecraft.shield.light_blue": "Lichtblauw schild",
  "item.minecraft.shield.light_gray": "Lichtgrijs schild",
  "item.minecraft.shield.lime": "Lichtgroen schild",
  "item.minecraft.shield.magenta": "Magenta schild",
  "item.minecraft.shield.orange": "Oranje schild",
  "item.minecraft.shield.pink": "Roze schild",
  "item.minecraft.shield.purple": "Paars schild",
  "item.minecraft.shield.red": "Rood schild",
  "item.minecraft.shield.white": "Wit schild",
  "item.minecraft.shield.yellow": "Geel schild",
  "item.minecraft.shulker_shell": "Shulkerschelp",
  "item.minecraft.shulker_spawn_egg": "Shulkerspawnei",
  "item.minecraft.sign": "Bord",
  "item.minecraft.silence_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Harnasversiering 'stilte'",
  "item.minecraft.silverfish_spawn_egg": "Zilvervissenspawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skeletpaardenspawnei",
  "item.minecraft.skeleton_spawn_egg": "Skelettenspawnei",
  "item.minecraft.skull_banner_pattern": "Banierpatroon",
  "item.minecraft.skull_banner_pattern.desc": "Schedelwapen",
  "item.minecraft.skull_banner_pattern.new": "Schedelwapenbanierpatroon",
  "item.minecraft.skull_pottery_shard": "Aardewerkscherf 'schedel'",
  "item.minecraft.skull_pottery_sherd": "Aardewerkscherf 'schedel'",
  "item.minecraft.slime_ball": "Slijmbal",
  "item.minecraft.slime_spawn_egg": "Slijmkubusspawnei",
  "item.minecraft.smithing_template": "Smeedssjabloon",
  "item.minecraft.smithing_template.applies_to": "Van toepassing op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Staaf of kristal toevoegen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Harnas",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Harnasstuk toevoegen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Staven en kristallen",
  "item.minecraft.smithing_template.ingredients": "Ingrediënten:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netherietstaaf toevoegen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamanten uitrusting",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Diamanten harnas, wapen of gereedschap toevoegen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherietstaaf",
  "item.minecraft.smithing_template.upgrade": "Upgrade(s): ",
  "item.minecraft.sniffer_spawn_egg": "Snuffelaarspawnei",
  "item.minecraft.snort_pottery_shard": "Aardewerkscherf 'snuffelen'",
  "item.minecraft.snort_pottery_sherd": "Aardewerkscherf 'snuffelen'",
  "item.minecraft.snout_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Harnasversiering 'snoet'",
  "item.minecraft.snow_golem_spawn_egg": "Sneeuwgolemspawnei",
  "item.minecraft.snowball": "Sneeuwbal",
  "item.minecraft.spectral_arrow": "Spectrale pijl",
  "item.minecraft.spider_eye": "Spinnenoog",
  "item.minecraft.spider_spawn_egg": "Spinnenspawnei",
  "item.minecraft.spire_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Harnasversiering 'piek'",
  "item.minecraft.splash_potion": "Spattende drank",
  "item.minecraft.splash_potion.effect.awkward": "Spattende vreemde drank",
  "item.minecraft.splash_potion.effect.empty": "Spattende onmaakbare drank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Spattende drank der vuurbestendigheid",
  "item.minecraft.splash_potion.effect.harming": "Spattende drank der verwonding",
  "item.minecraft.splash_potion.effect.healing": "Spattende drank der genezing",
  "item.minecraft.splash_potion.effect.infested": "Spattende drank der infestatie",
  "item.minecraft.splash_potion.effect.invisibility": "Spattende drank der onzichtbaarheid",
  "item.minecraft.splash_potion.effect.leaping": "Spattende drank der sprongen",
  "item.minecraft.splash_potion.effect.levitation": "Spattende drank der zweving",
  "item.minecraft.splash_potion.effect.luck": "Spattende drank des geluks",
  "item.minecraft.splash_potion.effect.mundane": "Spattende triviale drank",
  "item.minecraft.splash_potion.effect.night_vision": "Spattende drank des nachtzichts",
  "item.minecraft.splash_potion.effect.oozing": "Spattende drank der slijmerigheid",
  "item.minecraft.splash_potion.effect.poison": "Spattende drank des gifs",
  "item.minecraft.splash_potion.effect.regeneration": "Spattende drank der regeneratie",
  "item.minecraft.splash_potion.effect.slow_falling": "Spattende drank der valvertraging",
  "item.minecraft.splash_potion.effect.slowness": "Spattende drank der traagheid",
  "item.minecraft.splash_potion.effect.strength": "Spattende drank der kracht",
  "item.minecraft.splash_potion.effect.swiftness": "Spattende drank der vlotheid",
  "item.minecraft.splash_potion.effect.thick": "Spattende stroperige drank",
  "item.minecraft.splash_potion.effect.turtle_master": "Spattende drank der schildpadmeester",
  "item.minecraft.splash_potion.effect.water": "Spattende waterfles",
  "item.minecraft.splash_potion.effect.water_breathing": "Spattende drank des wateradems",
  "item.minecraft.splash_potion.effect.weakness": "Spattende drank der zwakheid",
  "item.minecraft.splash_potion.effect.weaving": "Spattende drank der weven",
  "item.minecraft.splash_potion.effect.wind_charged": "Spattende drank des jagende winds",
  "item.minecraft.spruce_boat": "Sparrenhouten boot",
  "item.minecraft.spruce_chest_boat": "Sparrenhouten boot met kist",
  "item.minecraft.spyglass": "Verrekijker",
  "item.minecraft.squid_spawn_egg": "Inktvissenspawnei",
  "item.minecraft.stick": "Stok",
  "item.minecraft.stone_axe": "Stenen bijl",
  "item.minecraft.stone_hoe": "Stenen schoffel",
  "item.minecraft.stone_pickaxe": "Stenen houweel",
  "item.minecraft.stone_shovel": "Stenen schep",
  "item.minecraft.stone_spear": "Stenen speer",
  "item.minecraft.stone_sword": "Stenen zwaard",
  "item.minecraft.stray_spawn_egg": "Verdwaaldenspawnei",
  "item.minecraft.strider_spawn_egg": "Lavarijderspawnei",
  "item.minecraft.string": "Draad",
  "item.minecraft.sugar": "Suiker",
  "item.minecraft.suspicious_stew": "Geheimzinnige stoofpot",
  "item.minecraft.sweet_berries": "Zoetbessen",
  "item.minecraft.tadpole_bucket": "Emmer kikkervis",
  "item.minecraft.tadpole_spawn_egg": "Kikkervisspawnei",
  "item.minecraft.tide_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Harnasversiering 'getijde'",
  "item.minecraft.tipped_arrow": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.awkward": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.empty": "Onmaakbare getipte pijl",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pijl der vuurbestendigheid",
  "item.minecraft.tipped_arrow.effect.harming": "Pijl der verwonding",
  "item.minecraft.tipped_arrow.effect.healing": "Pijl der genezing",
  "item.minecraft.tipped_arrow.effect.infested": "Pijl der infestatie",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pijl der onzichtbaarheid",
  "item.minecraft.tipped_arrow.effect.leaping": "Pijl der sprongen",
  "item.minecraft.tipped_arrow.effect.levitation": "Pijl der zweving",
  "item.minecraft.tipped_arrow.effect.luck": "Pijl des geluks",
  "item.minecraft.tipped_arrow.effect.mundane": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pijl des nachtzichts",
  "item.minecraft.tipped_arrow.effect.oozing": "Pijl der slijmerigheid",
  "item.minecraft.tipped_arrow.effect.poison": "Pijl des gifs",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pijl der regeneratie",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pijl der valvertraging",
  "item.minecraft.tipped_arrow.effect.slowness": "Pijl der traagheid",
  "item.minecraft.tipped_arrow.effect.strength": "Pijl der kracht",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pijl der vlotheid",
  "item.minecraft.tipped_arrow.effect.thick": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pijl der schildpadmeester",
  "item.minecraft.tipped_arrow.effect.water": "Pijl der spatting",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pijl des wateradems",
  "item.minecraft.tipped_arrow.effect.weakness": "Pijl der zwakheid",
  "item.minecraft.tipped_arrow.effect.weaving": "Pijl der weven",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pijl des jagende winds",
  "item.minecraft.tnt_minecart": "Mijnkar met TNT",
  "item.minecraft.torchflower_seeds": "Fakkelbloemzaden",
  "item.minecraft.totem_of_undying": "Totem der onsterfelijkheid",
  "item.minecraft.trader_llama_spawn_egg": "Handelaarslamaspawnei",
  "item.minecraft.trial_key": "Beproevingssleutel",
  "item.minecraft.trident": "Drietand",
  "item.minecraft.tropical_fish": "Tropische vis",
  "item.minecraft.tropical_fish_bucket": "Emmer tropische vis",
  "item.minecraft.tropical_fish_spawn_egg": "Tropischevissenspawnei",
  "item.minecraft.turtle_helmet": "Schildpadschild",
  "item.minecraft.turtle_scute": "Schildpadhoornschild",
  "item.minecraft.turtle_spawn_egg": "Schildpaddenspawnei",
  "item.minecraft.vex_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Harnasversiering 'ergernis'",
  "item.minecraft.vex_spawn_egg": "Ergernissenspawnei",
  "item.minecraft.villager_spawn_egg": "Dorpelingenspawnei",
  "item.minecraft.vindicator_spawn_egg": "Verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "Rondreizendehandelaarsspawnei",
  "item.minecraft.ward_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Harnasversiering 'hoeder'",
  "item.minecraft.warden_spawn_egg": "Hoederspawnei",
  "item.minecraft.warped_fungus_on_a_stick": "Spookachtige zwam aan een stok",
  "item.minecraft.water_bucket": "Emmer water",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Harnasversiering 'padvinder'",
  "item.minecraft.wheat": "Tarwe",
  "item.minecraft.wheat_seeds": "Tarwezaden",
  "item.minecraft.white_bundle": "Witte bundel",
  "item.minecraft.white_dye": "Witte kleurstof",
  "item.minecraft.white_harness": "Wit tuig",
  "item.minecraft.wild_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Harnasversiering 'verwilderd'",
  "item.minecraft.wind_charge": "Windvlaag",
  "item.minecraft.witch_spawn_egg": "Heksenspawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelettenspawnei",
  "item.minecraft.wither_spawn_egg": "Witherspawnei",
  "item.minecraft.wolf_armor": "Wolvenharnas",
  "item.minecraft.wolf_spawn_egg": "Wolvenspawnei",
  "item.minecraft.wooden_axe": "Houten bijl",
  "item.minecraft.wooden_hoe": "Houten schoffel",
  "item.minecraft.wooden_pickaxe": "Houten houweel",
  "item.minecraft.wooden_shovel": "Houten schep",
  "item.minecraft.wooden_spear": "Houten speer",
  "item.minecraft.wooden_sword": "Houten zwaard",
  "item.minecraft.writable_book": "Boek en veer",
  "item.minecraft.written_book": "Geschreven boek",
  "item.minecraft.yellow_bundle": "Gele bundel",
  "item.minecraft.yellow_dye": "Gele kleurstof",
  "item.minecraft.yellow_harness": "Geel tuig",
  "item.minecraft.zoglin_spawn_egg": "Zoglinspawnei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepaardenspawnei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilusspawnei",
  "item.minecraft.zombie_spawn_egg": "Zombiespawnei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorpelingenspawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombiepiglinspawnei"
}
export const nl_nl = items; 
